export default {
  "nav": {
    "feed": "Alimentación",
    "map": "Mapa",
    "discover": "Vibes",
    "plans": "Planes",
    "messages": "Charla",
    "profile": "Perfil"
  },
  "common": {
    "back": "Atrás",
    "cancel": "Cancelar",
    "save": "Guardar",
    "saving": "Guardando...",
    "edit": "Editar",
    "delete": "Eliminar",
    "remove": "Quitar",
    "refresh": "Actualizar",
    "error": "Error",
    "loading": "Cargando...",
    "tryAgain": "Por favor, inténtalo de nuevo.",
    "clear": "Borrar",
    "enable": "Habilitar",
    "tapToRetry": "Toca para volver a intentarlo",
    "somethingWentWrong": "Algo salió mal.",
    "comingSoon": "PRÓXIMAMENTE",
    "send": "Enviar",
    "ok": "Aceptar",
    "gotIt": "Entendido",
    "couldNotOpenLink": "No se pudo abrir el enlace.",
    "done": "Listo",
    "retry": "Reintentar",
    "later": "Más tarde",
    "notNow": "Ahora no",
    "openSettings": "Abrir ajustes",
    "loadingTonyte": "Cargando Tonyte…",
    "findingYourVibe": "Buscando tu vibra…",
    "almostThere": "Ya casi está…",
    "stillGettingThingsReady": "Seguimos preparando todo…",
    "profileLoadErrorTitle": "No se pudo cargar tu perfil",
    "profileLoadErrorMessage": "Comprueba tu conexión e inténtalo de nuevo.",
    "continue": "Continuar",
    "unknown": "Desconocido",
    "unknownError": "Error desconocido.",
    "user": "usuario",
    "sharedOnTonyte": "{name} en Tonyte"
  },
  "auth": {
    "signInRequired": "Es necesario iniciar sesión",
    "signInToUseFeature": "Inicie sesión para utilizar esta función.",
    "emailAlreadyInUse": "Ya existe una cuenta con este correo electrónico. Inicia sesión en su lugar.",
    "invalidEmail": "Ingrese una dirección de correo electrónico válida.",
    "invalidCredentials": "El correo electrónico o la contraseña son incorrectos.",
    "weakPassword": "Utilice una contraseña de al menos 6 caracteres.",
    "methodNotEnabled": "Este método de inicio de sesión aún no está habilitado.",
    "networkError": "Error de red. Comprueba tu conexión y vuelve a intentarlo.",
    "signInFailed": "Error al iniciar sesión. Por favor inténtalo de nuevo.",
    "notSignedIn": "No iniciado sesión.",
    "googleSignInUnavailable": "El inicio de sesión de Google no está disponible en esta versión. Reconstruya la aplicación después de instalar las dependencias nativas.",
    "googleSignInCancelled": "Se canceló el inicio de sesión de Google.",
    "googleMissingIdToken": "El inicio de sesión de Google no devolvió un token de identificación.",
    "appleSignInUnavailable": "El inicio de sesión de Apple no está disponible en este dispositivo.",
    "appleMissingIdentityToken": "El inicio de sesión de Apple no devolvió un token de identidad.",
    "appleSignInCancelled": "El inicio de sesión de Apple fue cancelado."
  },
  "verifyEmail": {
    "title": "Verifica tu correo electrónico",
    "subtitle": "Enviamos un enlace de verificación a",
    "instructions": "Toca el enlace en ese correo y luego vuelve aquí para tocar \"Comprobar de nuevo\".",
    "resend": "Reenviar correo de verificación",
    "resendCooldown": "Reenvío disponible en {count}s",
    "resendSuccess": "Correo de verificación enviado.",
    "resendFailure": "No se pudo enviar el correo de verificación. Inténtalo de nuevo.",
    "resendRateLimited": "Espera un momento antes de solicitar otro correo.",
    "checkAgain": "Comprobar de nuevo",
    "checking": "Comprobando…",
    "stillNotVerified": "Aún no verificado",
    "stillNotVerifiedMessage": "Todavía no vemos un correo verificado para esta cuenta. Revisa tu bandeja de entrada (y la carpeta de spam) e inténtalo de nuevo.",
    "verifiedSuccess": "¡Correo verificado! Ahora tienes acceso completo.",
    "continueBrowsing": "Seguir explorando Eventos y Mapa",
    "logout": "Cerrar sesión / cambiar de cuenta",
    "limitedAccessBanner": "Verifica tu correo para desbloquear Vibe, Planes, chat y más.",
    "limitedAccessBannerAction": "Verificar ahora",
    "gateTitle": "Verifica primero tu correo",
    "gateMessage": "Esta función se desbloquea al verificar tu dirección de correo electrónico.",
    "gateAction": "Verificar ahora"
  },
  "resetPassword": {
    "title": "Restablece tu contraseña",
    "subtitle": "Elige una nueva contraseña para tu cuenta de Tonyte.",
    "expiredLink": "Este enlace ha caducado. Solicita uno nuevo desde Tonyte.",
    "invalidLink": "Este enlace no es válido o ya se ha utilizado.",
    "weakPassword": "Usa una contraseña de al menos 6 caracteres.",
    "networkError": "Error de red. Comprueba tu conexión e inténtalo de nuevo.",
    "verifyFailed": "No hemos podido verificar este enlace. Solicita uno nuevo.",
    "missingCode": "A este enlace le falta el código de verificación.",
    "mismatch": "Las contraseñas no coinciden.",
    "verifying": "Verificando el enlace...",
    "updating": "Actualizando la contraseña...",
    "success": "Contraseña actualizada correctamente",
    "continueToLogin": "Continuar al inicio de sesión",
    "unavailable": "Enlace no disponible",
    "resettingFor": "Restableciendo la contraseña de {email}",
    "newPassword": "Nueva contraseña",
    "minimumCharacters": "Al menos 6 caracteres",
    "confirmPassword": "Confirmar contraseña",
    "enterAgain": "Vuelve a introducir la contraseña",
    "updatePassword": "Actualizar contraseña"
  },
  "vibesList": {
    "eyebrow": "TU GENTE",
    "title": "Vibes",
    "search": "Busca en tus vibes",
    "noMatches": "No hay vibes que coincidan",
    "noMatchesSub": "Busca por nombre, usuario, ciudad o universidad.",
    "empty": "Aún no tienes vibes",
    "emptySub": "Las personas con las que conectes mediante chats y vibes aparecerán aquí.",
    "openDailyVibes": "Ir a Daily Vibes",
    "removeTitle": "¿Eliminar este vibe?",
    "removeBody": "Se eliminará de tu lista de Vibes, pero se conservará el historial del chat.",
    "removeFailed": "No se ha podido eliminar este vibe.",
    "message": "Mensaje",
    "viewProfile": "Ver perfil",
    "community": "Comunidad Tonyte",
    "recentlyActive": "Activo recientemente",
    "activeMinutes": "Activo hace {count} min",
    "activeHours": "Activo hace {count} h",
    "activeDays": "Activo hace {count} d",
    "removeAccessibility": "Eliminar a {name} de Vibes",
    "removeSuccess": "{name} se ha eliminado de tus Vibes"
  },
  "partner": {
    "profileSelectorTitle": "Elige un perfil de socio",
    "profileSelectorBody": "Esta cuenta gestiona más de un socio.",
    "profileUnavailableTitle": "Perfil de socio no disponible",
    "profileLoadFailed": "No pudimos comprobar tu acceso de socio. Inténtalo de nuevo sin perder los datos de tu cuenta.",
    "profileLinkMissing": "Tu cuenta de socio está activa, pero no tiene ningún perfil de socio vinculado. Contacta con el soporte de Tonyte para recuperar el acceso.",
    "publicProfileUnavailableBody": "Este perfil de socio no está disponible en este momento.",
    "publicProfileLoadFailed": "No pudimos cargar este perfil. Revisa tu conexión e inténtalo de nuevo.",
    "kicker": "Tonyte Partner",
    "tools": "Herramientas para partners",
    "profile": "Perfil de partner",
    "profileSub": "Gestiona cómo aparece tu negocio en Tonyte",
    "createEvent": "Crear evento",
    "createEventSub": "Publica un nuevo evento",
    "myEvents": "Mis eventos",
    "myEventsSub": "Consulta, edita o elimina tus eventos próximos y activos",
    "analytics": "Analíticas",
    "analyticsSub": "Visitas, personas interesadas y veces compartido",
    "notifications": "Notificaciones",
    "notificationsSub": "Hitos y novedades sobre tus eventos",
    "noNotifications": "Aún no hay notificaciones.",
    "totalTaps": "Visitas totales",
    "interestedTaps": "Personas interesadas",
    "shares": "Veces compartido",
    "byEvent": "Por evento",
    "noAnalytics": "Aún no hay eventos. Publica el primero para ver sus analíticas.",
    "untitledEvent": "Evento sin título",
    "taps": "visitas",
    "interested": "interesadas",
    "sharesLower": "compartidos",
    "createPassword": "Crea tu contraseña",
    "firstSignIn": "Es tu primer inicio de sesión: crea una contraseña para continuar.",
    "setPasswordContinue": "Crear contraseña y continuar",
    "setPasswordFailed": "No se ha podido crear la contraseña. Inténtalo de nuevo.",
    "signOut": "Cerrar sesión",
    "notAssigned": "Aún no asignado",
    "categoryMissing": "Tu categoría de socio aún no ha sido asignada. Comuníquese con el administrador de Tonyte para configurar la categoría de su cuenta.",
    "typeCommunity": "Comunidad",
    "typeOrganizer": "Organizador",
    "typeVenue": "Lugar",
    "typeUniversity": "Universidad",
    "typeStudentOrganization": "Organización estudiantil",
    "businessName": "Nombre comercial",
    "description": "Descripción",
    "descriptionPlaceholder": "Cuéntale a la gente de qué se trata",
    "website": "Sitio web",
    "instagram": "Instagram",
    "venueAddress": "Dirección del lugar",
    "venueAddressPlaceholder": "Calle, ciudad, país",
    "saveChanges": "Guardar cambios",
    "viewTerms": "Ver términos de socios",
    "requiredFields": "El nombre comercial y la descripción son obligatorios.",
    "venueAddressRequired": "Se requiere una dirección del lugar.",
    "profileUpdated": "Perfil actualizado.",
    "profileSaveFailed": "No se pudo guardar tu perfil. Por favor inténtalo de nuevo."
  },
  "editProfile": {
    "nameRequired": "El nombre es obligatorio",
    "addName": "Añade un nombre antes de guardar el perfil.",
    "invalidDob": "Fecha de nacimiento no válida",
    "ageRequirement": "Tonyte es para personas de {age} años o más. Comprueba tu fecha de nacimiento.",
    "saveFailed": "No se ha podido guardar el perfil",
    "name": "Nombre *",
    "yourName": "Tu nombre",
    "bio": "Biografía",
    "bioPlaceholder": "Cuéntale algo sobre ti a la comunidad…",
    "city": "Ciudad",
    "yourCity": "Tu ciudad",
    "country": "País",
    "yourCountry": "Tu país",
    "dateOfBirth": "Fecha de nacimiento",
    "personality": "Personalidad",
    "selectedCount": "{count}/30 seleccionados",
    "addCustom": "Añadir «{interest}»"
  },
  "waitingList": {
    "title": "Estás en lista de espera",
    "badge": "ACCESO TEMPRANO",
    "headline": "Deja de desplazarte.\nEmpieza a salir.",
    "supportingText": "Estamos invitando gradualmente a nuevos miembros para mantener la comunidad auténtica, activa y segura.",
    "featureEventsTitle": "Buscar eventos",
    "featureEventsBody": "Descubre lo que sucede a tu alrededor.",
    "featurePlansTitle": "Crear planes",
    "featurePlansBody": "Inicie un plan y encuentre personas a quienes unirse.",
    "featureVibeTitle": "Diario Vibe",
    "featureVibeBody": "Responde algunas preguntas y descubre tus coincidencias con vibe.",
    "featureTogetherTitle": "Nunca te sientas solo",
    "featureTogetherBody": "Siempre encuentra algo que hacer y alguien con quien hacerlo.",
    "applicationReceived": "Solicitud recibida",
    "notificationText": "Te notificaremos tan pronto como se active tu cuenta.",
    "currentCity": "Ciudad actual",
    "footer": "Gracias por ayudarnos a construir el futuro del descubrimiento social.",
    "visitWebsite": "Visitar sitio web",
    "visitWebsiteSub": "Mira cómo funciona Tonyte →"
  },
  "login": {
    "missingDetails": "Detalles faltantes",
    "enterEmailPassword": "Ingresa tu correo electrónico y contraseña.",
    "passwordTooShort": "Contraseña demasiado corta",
    "passwordMin": "Utilice al menos 6 caracteres.",
    "emailSignInFailed": "Error en la autenticación de correo electrónico",
    "emailRequired": "Correo electrónico requerido",
    "enterResetEmail": "Ingrese su dirección de correo electrónico para restablecer su contraseña.",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "resetEmailSent": "Restablecer correo electrónico enviado",
    "resetEmailSentMessage": "Busque en su bandeja de entrada un enlace para restablecer su contraseña.",
    "passwordResetFailed": "Error al restablecer la contraseña",
    "signInFailed": "Error al iniciar sesión",
    "appleSignInFailed": "Apple Error al iniciar sesión",
    "signInWithEmail": "Iniciar sesión con correo electrónico",
    "createYourAccount": "Crea tu cuenta",
    "signIn": "Iniciar sesión",
    "create": "Regístrate",
    "createAccount": "Crear cuenta",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "findYour": "Encuentra tu",
    "people": "personas",
    "plans": "planes",
    "tagline": "Deja de desplazarte.\nEmpieza a salir.",
    "featurePeople": "Encuentra a tu gente",
    "featureEvents": "Mira lo que hay",
    "featureAlone": "Nunca salgas solo",
    "continueWithEmail": "Continuar con el correo electrónico",
    "continueWithGoogle": "Continuar con Google",
    "continueWithApple": "Continuar con Apple",
    "legalPrefix": "Al continuar, aceptas nuestra",
    "and": "y",
    "partnerSignInHint": "¿Eres partner de Tonyte? Inicia sesión arriba con tu ID de partner o correo electrónico"
  },
  "settings": {
    "title": "Configuración",
    "account": "Cuenta",
    "appearance": "Apariencia",
    "midnight": "Midnight",
    "daylight": "Daylight",
    "language": "Idioma",
    "appLanguage": "Idioma de la aplicación",
    "languageSaved": "Idioma guardado",
    "languageSaveError": "No se pudo guardar el idioma.",
    "profileManagement": "Gestión de perfiles",
    "profileCompleted": "Perfil completado",
    "profileCompletedSub": "Las respuestas de tu perfil están completamente configuradas.",
    "editProfile": "Editar perfil",
    "editProfileAnswers": "Editar respuestas del perfil",
    "completeProfile": "Perfil completo",
    "notifications": "Notificaciones",
    "pushNotifications": "Notificaciones automáticas",
    "legal": "Legales",
    "privacyPolicy": "Política de privacidad",
    "termsOfService": "Términos de servicio",
    "communityGuidelines": "Normas de la comunidad",
    "impressum": "Impresión",
    "partnerTerms": "Términos del socio",
    "dataDeletionRequest": "Solicitud de eliminación de datos",
    "about": "Acerca de",
    "tagline": "Conoce gente. Live la noche.",
    "accountPrivacy": "Privacidad de la cuenta",
    "blockedAccounts": "Cuentas bloqueadas",
    "faq": "FAQ",
    "helpFeedback": "Ayuda y comentarios",
    "verificationCenter": "Centro de verificación",
    "savedTemplates": "Plantillas guardadas",
    "uploadedPlans": "Planos Subidos",
    "adminControls": "Controles administrativos",
    "dataDeletion": "Eliminación de datos",
    "logout": "Cerrar sesión",
    "deleteAccount": "Eliminar cuenta",
    "studentVerification": "Verificación de Estudiante",
    "vibeVerification": "Obtenga Vibe verificado",
    "tonyteSettings": "Configuración de Tonyte",
    "version": "Versión {version}",
    "search": "Configuración de búsqueda",
    "clearSearch": "Borrar búsqueda de configuración",
    "profile": "Perfil",
    "partnerDashboard": "Panel de control de socios",
    "preferences": "Preferencias",
    "privacyLegal": "Privacidad y Legal",
    "support": "Soporte",
    "session": "Sesión",
    "noSettings": "No se encontraron configuraciones",
    "noSettingsSub": "Pruebe con una palabra clave diferente.",
    "connectedEmail": "Correo electrónico conectado",
    "noEmail": "No hay ningún correo electrónico conectado",
    "signInMethod": "Método de inicio de sesión",
    "noSignInMethod": "No se encontró ningún método de inicio de sesión.",
    "passwordLogin": "Inicio de sesión con contraseña habilitado",
    "connected": "{provider} conectado",
    "sendReset": "Enviar Restablecer Contraseña",
    "sending": "Enviando...",
    "unblock": "Desbloquear",
    "noBlocked": "No hay cuentas bloqueadas.",
    "searchFaq": "Buscar preguntas frecuentes",
    "feedbackPlaceholder": "Cuéntanos qué tienes en mente...",
    "feedbackEmail": "Correo electrónico de contacto (opcional)",
    "sendFeedback": "Enviar comentarios",
    "chatNotifications": "Mensajes y Vibes",
    "eventNotifications": "Planes",
    "eventRecommendationNotifications": "Eventos y recomendaciones",
    "partnerNotifications": "Partners que sigo",
    "verifiedStudent": "Estudiante verificado",
    "verifiedStudentSub": "Tienes acceso completo a eventos exclusivos para estudiantes. Su correo electrónico de estudiante se mantiene privado.",
    "checkInbox": "Revisa tu bandeja de entrada",
    "verificationSentPrefix": "Enviamos un enlace de verificación a",
    "verificationSentSuffix": "Haga clic en el enlace de ese correo electrónico para confirmar la propiedad.",
    "linkExpiry": "El enlace caduca en 24 horas. Revisa tu carpeta de spam si no la ves.",
    "wrongEmail": "¿Correo electrónico incorrecto?",
    "differentUniversityEmail": "Ingresa un correo electrónico universitario diferente",
    "resendVerification": "Reenviar correo electrónico de verificación",
    "pendingReview": "Pendiente de revisión",
    "pendingReviewSub": "Se confirmó la propiedad de tu correo electrónico. Un administrador revisará su institución en breve. Obtendrá acceso una vez aprobado.",
    "verificationFailed": "Verificación fallida",
    "studentFailedSub": "Tu verificación no fue aprobada. Inténtalo de nuevo con un correo electrónico universitario válido.",
    "universityEmail": "Correo electrónico universidad/estudiante",
    "universityEmailHelp": "Ingresa el correo electrónico de tu universidad. Le enviaremos un enlace de verificación. Las instituciones conocidas se aprueban instantáneamente; otros se revisan dentro de las 24 horas.",
    "sendVerification": "Enviar correo electrónico de verificación",
    "vibeVerifiedTitle": "Vibe Verificado",
    "vibeVerifiedSub": "Tu perfil tiene la insignia. Otros usuarios ven confianza, no tu selfie.",
    "privacy": "Privacidad",
    "verificationPrivacy": "Su selfie de verificación se revisa manualmente y se elimina una vez que se completa la decisión de verificación. Los medios de verificación se utilizan únicamente para la revisión manual: Tonyte no utiliza reconocimiento facial, análisis biométrico ni verificación automatizada.",
    "verificationPending": "Verificación pendiente",
    "verificationPendingSub": "Tu selfie está en la cola de revisión. Obtendrá la insignia de Verificado Vibe después de la aprobación.",
    "submittingSelfie": "Enviando tu selfie…",
    "pendingAdminSub": "Tu solicitud permanecerá pendiente hasta que un administrador la revise.",
    "selfieFailedSub": "Vuelve a tomarte la selfie con buena iluminación, tu rostro visible y el gesto encuadrado.",
    "tryAgain": "Vuelve a intentarlo",
    "reviewSelfie": "Revisa tu selfie",
    "reviewSelfieSub": "Asegúrate de que tu rostro y tus gestos sean claros antes de enviarlo.",
    "retake": "Retomar",
    "submitReview": "Enviar para revisión",
    "getVerified": "Obtenga Vibe verificado",
    "getVerifiedSub": "Tómate una selfie rápida para demostrar que eres una persona real y generar confianza con los demás. Su selfie de verificación se revisa manualmente y se elimina una vez que se completa la decisión de verificación.",
    "examplePose": "Ejemplo de pose",
    "matchPose": "Tómate una selfie que coincida con la pose de arriba.",
    "faceVisible": "Cara claramente visible",
    "gestureVisible": "Gesto de la mano visible",
    "goodLighting": "Buena iluminación",
    "noFilters": "Sin filtros ni capturas de pantalla",
    "takeVerificationSelfie": "Tomar selfie de verificación",
    "deleteAccountTitle": "Eliminar cuenta",
    "deleteAccountConfirm": "¿Estás seguro de que deseas eliminar permanentemente tu cuenta Tonyte? Esta acción no se puede deshacer.",
    "deleteProfileInfo": "Tu perfil ya no será visible.",
    "deleteDataInfo": "Se eliminarán tus chats privados, coincidencias, bloqueos, deslizamientos y datos de cuenta.",
    "deletePlansInfo": "Se eliminarán tus planes comunitarios. Esta acción no elimina los eventos públicos.",
    "confirmIdentity": "Confirma que eres tú",
    "reauthenticate": "Por seguridad, vuelva a autenticarse con {provider} antes de que eliminemos su cuenta.",
    "enterPassword": "Ingresa tu contraseña",
    "loadingUsers": "Cargando usuarios…",
    "totalUsers": "Usuarios totales {count}",
    "searchUsers": "Buscar usuarios...",
    "noEmailAvailable": "No hay correo electrónico disponible",
    "protectedAccount": "Cuenta protegida",
    "revoking": "Revocando…",
    "revokeVerified": "Revocar Vibe Verificado",
    "suspendAccountAction": "Suspender",
    "unsuspendAccountAction": "Reactivar",
    "suspending": "Actualizando…",
    "suspendAccountTitle": "Suspender cuenta",
    "unsuspendAccountTitle": "Reactivar cuenta",
    "suspendAccountConfirm": "¿Suspender la cuenta de {name}? Se cerrará su sesión y no podrá volver a iniciar sesión hasta que se reactive.",
    "unsuspendAccountConfirm": "¿Reactivar la cuenta de {name}? Podrá volver a iniciar sesión.",
    "suspendAccountSuccess": "{name} ha sido suspendido.",
    "unsuspendAccountSuccess": "{name} ha sido reactivado.",
    "suspendAccountFailed": "No se pudo suspender esta cuenta. Inténtalo de nuevo.",
    "unsuspendAccountFailed": "No se pudo reactivar esta cuenta. Inténtalo de nuevo.",
    "cannotSuspendSelf": "No puedes suspender tu propia cuenta.",
    "deleteAccountAction": "Eliminar cuenta",
    "deletingAccount": "Eliminando…",
    "deleteAccountTitle": "Eliminar cuenta",
    "deleteAccountConfirm1": "¿Eliminar permanentemente a {name} ({email})? Esto eliminará su cuenta de forma definitiva y no se puede deshacer.",
    "deleteAccountFinalTitle": "¿Estás completamente seguro?",
    "deleteAccountFinalBody": "Esto elimina la cuenta de forma permanente de Firebase Authentication y Tonyte. Esta acción no se puede deshacer.",
    "deleteAccountFinalAction": "Eliminar permanentemente",
    "deleteAccountSuccess": "{name} ha sido eliminado permanentemente.",
    "deleteAccountFailed": "No se pudo eliminar esta cuenta. Inténtalo de nuevo.",
    "cannotDeleteSelf": "No puedes eliminar tu propia cuenta.",
    "cannotDeleteAdmin": "Los administradores no pueden eliminar otras cuentas de administrador.",
    "noUsers": "No se encontraron usuarios",
    "noPendingRequests": "No hay solicitudes pendientes",
    "requestedEmail": "Correo electrónico solicitado",
    "domain": "Dominio",
    "requested": "Solicitado",
    "emailOwnership": "Propiedad del correo electrónico",
    "confirmed": "Confirmado",
    "notConfirmed": "No confirmado",
    "accept": "Aceptar",
    "noPendingFace": "No hay solicitudes de rostro pendientes",
    "noAccountEmail": "No hay cuenta de correo electrónico",
    "shakaSelfie": "Selfie de Shaka",
    "posePassLabel": "Pose",
    "livenessPassLabel": "Liveness",
    "front": "Frente",
    "left": "Izquierda",
    "right": "Derecha",
    "approve": "Aprobar",
    "reject": "Rechazar",
    "eventCity": "Ciudad del evento",
    "eventCityHelp": "Cambia tu ciudad de Feed y Mapa."
  },
  "chat": {
    "title": "Charla",
    "subtitle": "Chats, solicitudes vibe y vibes enviados",
    "chats": "Charlas",
    "vibeRequests": "Solicitudes Vibe",
    "sentVibes": "Enviado Vibes",
    "searchChats": "Buscar chats",
    "noMessages": "Aún no hay mensajes",
    "noChatsFound": "No se encontraron chats",
    "noChatsYet": "Aún no hay chats",
    "tryDifferentKeyword": "Pruebe con un nombre o palabra clave diferente.",
    "chatsAppearHere": "Tus chats aparecerán aquí",
    "joinToStart": "Únase a un evento o envíe un vibe para comenzar a chatear.",
    "signInToUseVibes": "Inicia sesión para usar vibes",
    "signInSub": "Crea una cuenta para ver solicitudes de vibe y chats privados.",
    "translateChat": "Traducir Chat",
    "translatingChat": "Traduciendo...",
    "showOriginal": "Mostrar original",
    "translationFailed": "No se pudo traducir el chat.",
    "chatUnmuted": "Chat activado",
    "chatMuted": "Chat silenciado",
    "leftChat": "Dejaste el chat",
    "blockUserQuestion": "¿Bloquear usuario?",
    "blockUserMessage": "Ya no verás mensajes de {name}. El bloqueo es unidireccional y no les notificará.",
    "thisUser": "este usuario",
    "block": "Bloquear",
    "userBlocked": "Usuario bloqueado",
    "couldNotBlockUser": "No se pudo bloquear al usuario",
    "deleteChatQuestion": "¿Eliminar chat?",
    "deleteChatMessage": "Este chat se eliminará permanentemente y no se podrá deshacer.",
    "chatDeleted": "Chat eliminado",
    "couldNotDeleteChat": "No se pudo eliminar el chat",
    "deletePlanMessage": "Esto eliminará permanentemente el plan y su chat para todos los participantes.",
    "vibePromptsReady": "Tus indicaciones de sincronización de vibe están listas",
    "you": "Tú",
    "traveler": "Miembro de Tonyte",
    "tonyteEvent": "EVENTO TONYTE",
    "openEvent": "Evento abierto",
    "directMessage": "Mensaje directo",
    "youBlockedUser": "Bloqueaste a este usuario",
    "unblockInSettings": "Desbloquéalos desde la configuración del perfil para ver este chat nuevamente.",
    "vibeEnded": "Este Vibe ha terminado",
    "vibeEndedBody": "Esta conexión y su historial de chat ya no existen. Envía una nueva solicitud de Vibe para reconectar.",
    "eventChatEnded": "Este evento ha terminado",
    "planChatEnded": "Este plan ha terminado",
    "removeFromPlan": "Quitar del plan",
    "removeFromPlanQuestion": "¿Quitar a {name} de este plan?",
    "removeFromPlanMessage": "Perderá el acceso al chat del plan y dejará de formar parte de él.",
    "removedFromPlan": "Has sido eliminado de este plan.",
    "memberRemoved": "Miembro eliminado",
    "couldNotRemoveMember": "No se pudo quitar a este miembro. Inténtalo de nuevo.",
    "typeMessage": "Escribe un mensaje...",
    "couldNotSendImage": "No se pudo enviar la imagen.",
    "locationUnavailable": "Ubicación no disponible.",
    "couldNotSendLocation": "No se pudo enviar la ubicación.",
    "sharedLocationLabel": "Ubicación compartida",
    "viewOnMap": "Ver en el mapa",
    "invalidSharedLocation": "Esta ubicación no se puede abrir ahora mismo.",
    "eventExpiredLabel": "CADUCADO",
    "eventExpired": "Evento caducado",
    "eventExpiredToast": "Este evento ya no está disponible.",
    "microphoneNowEnabled": "Acceso al micrófono activado",
    "reply": "Responder",
    "gifs": "GIFS",
    "gifSearchResults": "Resultados",
    "gifTrendingNow": "Tendencias",
    "searchGiphy": "Buscar en GIPHY",
    "recentlyUsed": "Usados recientemente",
    "gifsLoadFailed": "No se pudieron cargar los GIF. Comprueba tu conexión e inténtalo de nuevo.",
    "microphoneAccessNeeded": "Se necesita acceso al micrófono",
    "microphoneAccessMessage": "Tonyte necesita acceso al micrófono para enviar notas de voz. Actívalo en Ajustes para continuar.",
    "recordingUnavailable": "Grabación no disponible",
    "recordingUnavailableMessage": "No se pudo iniciar la grabación. Inténtalo de nuevo.",
    "wantsToVibe": "Quiere vibe contigo",
    "status": "Estado: {status}",
    "accepted": "Aceptado",
    "passed": "Aprobado",
    "pending": "Pendiente",
    "profileSource": "Perfil Tonyte",
    "sharedPlan": "Plan compartido",
    "sharedEvent": "Evento compartido",
    "noRequestMessage": "Aún no se ha agregado ningún mensaje.",
    "vibe": "Vibe",
    "pass": "Pasar",
    "alreadyVibing": "Ya Vibrando",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "vibeVerified": "Vibe Verificado",
    "bio": "Biografía",
    "interests": "Intereses",
    "requestMessage": "Solicitar mensaje",
    "viewProfile": "Ver perfil",
    "working": "Trabajando...",
    "cancelRequest": "Cancelar solicitud",
    "peopleHere": "GENTE AQUÍ",
    "connectTravelers": "Encuentra a tu gente",
    "loadingTravelers": "Cargando personas...",
    "tryAgain": "Inténtalo de nuevo",
    "noTravelers": "Todavía no hay nadie más aquí.",
    "noTravelersSub": "Sé el primero en abrir Personas aquí y tu tarjeta se mostrará a los demás.",
    "vibing": "Vibrando",
    "sent": "Enviado",
    "accept": "Aceptar",
    "sendVibe": "Enviar un vibe",
    "sendVibeSub": "Agregue una nota breve para {name}. También puedes enviarlo en blanco.",
    "optionalMessage": "Mensaje opcional...",
    "sending": "Enviando...",
    "sendVibeAction": "Enviar Vibe",
    "planChat": "PLANIFICAR CHAT",
    "eventChat": "CHAT DEL EVENTO",
    "communityPlan": "Plan Comunitario",
    "officialEvent": "Evento oficial",
    "vibingWith": "Vibrando con",
    "groupCount": "{count} {people} en este chat de {kind}",
    "person": "persona",
    "people": "personas",
    "plan": "plano",
    "event": "evento",
    "loadingMembers": "Cargando miembros...",
    "openProfiles": "Abrir perfiles y enviar vibes",
    "deleteChat": "Eliminar chat",
    "leaveChat": "Salir del chat",
    "adminCannotLeave": "Los administradores del plan no pueden salir del chat. ¿Eliminar este plan en su lugar?",
    "noStay": "No, quédate",
    "yesDeletePlan": "Sí, eliminar plan",
    "leavePlanConfirm": "¿Dejar este chat del plan? Puede volver a unirse desde la página del plan.",
    "leaveEventConfirm": "¿Dejar este chat de evento?",
    "leaving": "Saliendo…",
    "leave": "Salir",
    "safety": "SEGURIDAD",
    "reportPerson": "Informe {name}",
    "chooseReason": "Primero elige un motivo.",
    "reportFailed": "Informe fallido. Por favor inténtalo de nuevo.",
    "optionalDetails": "Detalles opcionales…",
    "submitReport": "Enviar informe",
    "reportUser": "Reportar usuario",
    "blockUser": "Bloquear usuario",
    "viewProfileTitle": "Ver perfil",
    "muteChat": "Silenciar chat",
    "unmuteChat": "Activar el silencio del chat",
    "loadingRequests": "Cargando solicitudes...",
    "noPendingRequests": "No hay solicitudes vibe pendientes",
    "pendingRequestsSub": "Las solicitudes recibidas aparecerán aquí antes de pasar a Chats.",
    "loadingSent": "Cargando enviado vibes...",
    "noSent": "Aún no se ha enviado vibes",
    "noSentSub": "El Vibes que envíes desde People Here será rastreado aquí.",
    "reasonSpam": "Correo no deseado",
    "reasonHarassment": "Acoso",
    "reasonFake": "Perfil falso",
    "reasonContent": "Contenido inapropiado",
    "reasonScam": "Estafa o comportamiento inseguro",
    "reasonOther": "Otro",
    "tonyteVenue": "ESPACIO TONYTE",
    "newMessage": "Nuevo mensaje",
    "newMessageFallback": "Recibiste un mensaje nuevo.",
    "someone": "Alguien",
    "requestAcceptFailed": "No se pudo aceptar la solicitud. Por favor inténtalo de nuevo.",
    "requestDeclineFailed": "No se pudo rechazar la solicitud. Por favor inténtalo de nuevo.",
    "requestCancelFailed": "No se pudo cancelar la solicitud. Por favor inténtalo de nuevo.",
    "travelersLoadFailed": "No se pudo cargar a las personas. Inténtalo de nuevo.",
    "signInSendVibes": "Inicie sesión para enviar solicitudes vibe.",
    "vibeRequestSendFailed": "No se pudo enviar la solicitud vibe. Por favor inténtalo de nuevo.",
    "nowVibingWith": "¡Ahora estás vibrando con {name}!",
    "leaveFailed": "No se pudo salir del chat. Por favor inténtalo de nuevo.",
    "requestPassed": "Solicitud aprobada",
    "gifSendFailed": "No se pudo enviar GIF. Intentar otra vez.",
    "voiceUploadFailed": "Error al cargar la nota de voz. Toca Reintentar en el mensaje.",
    "reportSubmitted": "Informe enviado",
    "now": "ahora",
    "minutesShort": "{count}m",
    "hoursShort": "{count}h",
    "daysShort": "{count}d",
    "vibingCount_one": "{count} persona en la vibra",
    "vibingCount_few": "{count} personas en la vibra",
    "vibingCount_many": "{count} personas en la vibra",
    "vibingCount_other": "{count} personas en la vibra",
    "memberJoined": "{name} se unió al chat",
    "memberLeft": "{name} salió del chat",
    "lastSeenJustNow": "Visto por última vez hace un momento",
    "lastSeenMinutes_one": "Última conexión hace {count} min",
    "lastSeenMinutes_few": "Última conexión hace {count} min",
    "lastSeenMinutes_many": "Última conexión hace {count} min",
    "lastSeenMinutes_other": "Última conexión hace {count} min",
    "lastSeenHours_one": "Visto por última vez hace {count}h",
    "lastSeenHours_few": "Visto por última vez hace {count}h",
    "lastSeenHours_many": "Visto por última vez hace {count}h",
    "lastSeenHours_other": "Visto por última vez hace {count}h",
    "lastSeenYesterday": "Visto por última vez ayer",
    "lastSeenDays_one": "Visto por última vez hace {count}d",
    "lastSeenDays_few": "Visto por última vez hace {count}d",
    "lastSeenDays_many": "Visto por última vez hace {count}d",
    "lastSeenDays_other": "Visto por última vez hace {count}d",
    "lastSeenAWhileAgo": "Visto por última vez hace un tiempo",
    "seen": "Visto",
    "seenJustNow": "Visto hace un momento",
    "seenMinutes_one": "Visto hace {count} min",
    "seenMinutes_few": "Visto hace {count} min",
    "seenMinutes_many": "Visto hace {count} min",
    "seenMinutes_other": "Visto hace {count} min",
    "seenHours_one": "Visto hace {count}h",
    "seenHours_few": "Visto hace {count}h",
    "seenHours_many": "Visto hace {count}h",
    "seenHours_other": "Visto hace {count}h",
    "yesterday": "Ayer",
    "typing": "Escribiendo...",
    "online": "En línea",
    "studiZonePlan": "Plan de StudiZone"
  },
  "discover": {
    "heroTitle": "Vibes",
    "vibesSubtitle": "Gente. Lugares. Campus.",
    "findMyVibeTitle": "Encuentra mi vibe",
    "findMyVibeDesc": "Juega el quiz. Conoce a tu gente.",
    "venuesCardDesc": "Perfiles de socios.",
    "studiZoneCardDesc": "Comunidad del campus.",
    "statusOpensAt": "Abre {time}",
    "statusResultsAt": "Resultados {time}",
    "statusResultsOut": "Resultados listos",
    "studiZoneVerifiedOnly": "Estudiantes verificados",
    "infoPill": "Responde algunas preguntas. Consigue tu vibe. Encuentra a tu gente.",
    "addPhotoLocked": "Agrega una foto de perfil real antes de usar el descubrimiento social.",
    "daySubtitle": "Responde al vibe check de hoy",
    "dayDescription": "Responde unas preguntas diarias para descubrir tu aura, desbloquea tu Vibe Circle y conecta con personas en tu misma sintonía.",
    "venueSubtitle": "Descubre quién da vida a tu ciudad",
    "venueDescription": "Explora locales, artistas, comunidades y anfitriones de tu ciudad. Sigue tus favoritos y descubre sus eventos, novedades y calendarios.",
    "studiZoneTitle": "StudiZone",
    "studiZoneSubtitle": "Tu espacio para estudiantes verificados",
    "studiZoneDescription": "Descubre eventos universitarios, planes, comunidades y chats para estudiantes verificados.",
    "studiZoneButton": "Entrar en StudiZone ->",
    "letsGo": "Vamos ->",
    "citySync": "Sincronización de ciudad",
    "tonightSync": "Sincronización esta noche",
    "auraLockedText": "¿Nuevo aquí? No te preocupes.\nEl escaneo aura de hoy se abre a las 6:00 AM.",
    "auraQuestionsText": "Responde las preguntas.\nEncuentra tu aura y desbloquea tu círculo Vibe.",
    "auraResultsText": "Resultados.\nEncuentra tu aura y con quién estás vibe hoy.",
    "auraOpenTime": "6:00",
    "auraResultsTime": "1:00",
    "am": "AM",
    "pm": "PM",
    "live": "LIVE",
    "now": "AHORA",
    "underConstruction": "En construcción",
    "venueTesterUnavailable": "Vibe en Venues se está preparando para acceso temprano. Aura Vibe sigue disponible."
  },
  "feedFilters": {
    "now": "Ahora",
    "tonight": "Esta noche",
    "parties": "Partes",
    "social": "Redes sociales",
    "nearby": "Cerca",
    "high-energy": "Alta energía",
    "food": "Comida",
    "activities": "Actividades",
    "chill": "Frío",
    "date-idea": "Idea de fecha",
    "solo-friendly": "Amigable en solitario",
    "student": "Estudiante",
    "free": "Gratis"
  },
  "interests": {
    "addInterests": "Agregar intereses",
    "selectedInterests": "Intereses seleccionados",
    "selected": "seleccionado",
    "searchInterests": "Intereses de búsqueda",
    "add": "Agregar",
    "saveInterests": "Guardar intereses",
    "categories": {
      "travel": "Viajes",
      "food_and_drinks": "Alimentos y bebidas",
      "nightlife": "Vida nocturna",
      "sports_and_fitness": "Deportes y fitness",
      "music": "Música",
      "art_and_creativity": "Arte y Creatividad",
      "social_and_culture": "Social y Cultura",
      "tech_and_gaming": "Tecnología y juegos",
      "outdoors": "Al aire libre",
      "relax_and_lifestyle": "Relajación y estilo de vida"
    },
    "items": {
      "backpacking": "Mochilero",
      "road_trips": "Viajes por carretera",
      "solo_travel": "Viaje en solitario",
      "luxury_travel": "Viajes de lujo",
      "digital_nomad": "Nómada Digital",
      "adventure_travel": "Viajes de aventura",
      "city_exploration": "Exploración de la ciudad",
      "beach_trips": "Viajes a la playa",
      "mountains": "Montañas",
      "camping": "Acampar",
      "street_food": "Comida callejera",
      "fine_dining": "Cena elegante",
      "cafes": "Cafés",
      "bars": "Barras",
      "cocktails": "Cócteles",
      "wine_tasting": "Cata de vinos",
      "beer": "Cerveza",
      "cooking": "Cocinar",
      "vegan_food": "Comida Vegana",
      "desserts": "Postres",
      "clubbing": "Discotecas",
      "house_music": "Música casera",
      "techno": "Tecno",
      "hip_hop": "Hip Hop",
      "live_djs": "Live DJ",
      "pub_crawls": "Rutas de pubs",
      "after_parties": "Fiestas posteriores",
      "festivals": "Festivales",
      "dance": "Danza",
      "karaoke": "Karaoke",
      "gym": "Gimnasio",
      "running": "Corriendo",
      "football": "Fútbol",
      "basketball": "Baloncesto",
      "yoga": "Yoga",
      "hiking": "Senderismo",
      "cycling": "Ciclismo",
      "swimming": "Natación",
      "martial_arts": "Artes marciales",
      "crossfit": "CrossFit",
      "rap": "Rap",
      "pop": "Popular",
      "rock": "Roca",
      "edm": "EDM",
      "jazz": "Jazz",
      "classical": "Clásica",
      "indie": "Independiente",
      "lo_fi": "Lo-fi",
      "live_concerts": "Live Conciertos",
      "singing": "Cantando",
      "photography": "Fotografía",
      "painting": "Pintura",
      "graphic_design": "Diseño Gráfico",
      "illustration": "Ilustración",
      "3d_art": "Arte 3D",
      "videography": "Videografía",
      "content_creation": "Creación de contenido",
      "fashion": "Moda",
      "tattoo_art": "Arte del tatuaje",
      "animation": "Animación",
      "meeting_people": "Conociendo gente",
      "languages": "Idiomas",
      "cultural_exchange": "Intercambio Cultural",
      "volunteering": "Voluntariado",
      "networking": "Redes",
      "events": "Eventos",
      "public_speaking": "Hablar en público",
      "debates": "Debates",
      "history": "Historia",
      "museums": "Museos",
      "gaming": "Juegos",
      "pc_gaming": "Juegos de PC",
      "console_gaming": "Juegos de consola",
      "ai": "IA",
      "startups": "Inicios",
      "coding": "Codificación",
      "cybersecurity": "Ciberseguridad",
      "web3": "Web3",
      "gadgets": "Artilugios",
      "esports": "Deportes electrónicos",
      "nature": "Naturaleza",
      "sunsets": "Atardeceres",
      "photography_walks": "Paseos fotográficos",
      "picnics": "Picnics",
      "fishing": "Pesca",
      "climbing": "Escalada",
      "kayaking": "Kayak",
      "skiing": "Esquí",
      "snowboarding": "Snowboard",
      "wildlife": "Vida Silvestre",
      "netflix": "Netflix",
      "reading": "Lectura",
      "meditation": "Meditación",
      "spa": "Balneario",
      "journaling": "Diario",
      "podcasts": "Pódcasts",
      "shopping": "Compras",
      "minimalism": "Minimalismo",
      "self_growth": "Crecimiento personal",
      "coffee": "Café"
    }
  },
  "feed": {
    "free": "Gratis",
    "freeEntry": "Entrada gratuita",
    "paidEntry": "Entrada pagada",
    "ongoing": "En curso",
    "nowOn": "Ahora en adelante",
    "runsUntil": "Se ejecuta hasta",
    "until": "hasta",
    "peopleGoing": "personas asistirán",
    "peopleGoingCount_one": "Asistirá {count} persona",
    "peopleGoingCount_few": "Asistirán {count} personas",
    "peopleGoingCount_many": "Asistirán {count} personas",
    "peopleGoingCount_other": "Asistirán {count} personas",
    "tonyteVenue": "Lugar Tonyte",
    "ticketsFrom": "Entradas desde",
    "eyebrow": "Eventos oficiales y eventos organizados cerca",
    "whatsOnIn": "¿Qué hay en",
    "today": "Hoy",
    "tomorrow": "Mañana",
    "date": "Fecha",
    "gettingLocation": "Obteniendo tu ubicación...",
    "locationDenied": "Acceso a la ubicación denegado. Habilítelo en Configuración para ver eventos cercanos.",
    "enableLocation": "Habilita la ubicación para ver eventos cercanos.",
    "featuredThisWeek": "Destacados de la semana",
    "topPicksForYou": "Selección para ti",
    "popularNearYou": "Popular cerca de ti",
    "topPicksError": "No se pudieron cargar tus recomendaciones.",
    "topPicksSubtitle": "Eventos que coinciden con tus intereses",
    "topPicksSubtitlePopular": "Eventos populares cerca de ti",
    "topPicksSeeAll": "Ver todos",
    "topPicksBadge": "Para ti",
    "topPicksEyebrow": "Recomendado para ti",
    "topPicksReason": {
      "interest": "Porque te gusta {interest}",
      "category": "Coincide con tus intereses de {category}",
      "joined": "Similar a eventos a los que te uniste",
      "shared": "Similar a eventos que compartiste",
      "viewed": "Basado en eventos que has visto"
    },
    "allEvents": "Todos los eventos",
    "searchPlaceholder": "Encuentra tu próximo plan…",
    "searchAccessibility": "Busca eventos, clubs o etiquetas",
    "searchResults": "Resultados de búsqueda",
    "searchEmpty": "Ningún evento coincide con «{query}»",
    "searchEmptySub": "Prueba con otro nombre, club o etiqueta.",
    "loadingEvents": "Cargando eventos...",
    "noEventsFound": "No se encontraron eventos",
    "noEventsSub": "Vuelve pronto o prueba con un filtro diferente."
  },
  "featuredAdmin": {
    "title": "Destacar este evento",
    "thisWeek": "Esta semana",
    "nextWeek": "Próxima semana",
    "custom": "Personalizado",
    "startDate": "Fecha de inicio",
    "endDate": "Fecha de fin",
    "priority": "Prioridad de visualización",
    "priorityHint": "El 1 se muestra primero. Los números más bajos aparecen antes.",
    "currentlyFeatured": "Este evento está actualmente en Destacados de la semana.",
    "save": "Guardar",
    "saveAnyway": "Destacar de todos modos",
    "remove": "Quitar",
    "checkingPartner": "Comprobando la cuenta de socio…",
    "verifiedPartner": "Publicado por un socio verificado de Tonyte.",
    "notPartner": "Este evento no lo publicó una cuenta de socio verificada. Destacar está pensado para eventos de socios.",
    "unknownPartner": "No se pudo verificar la cuenta de socio. Destacar está pensado para eventos de socios.",
    "errors": {
      "invalidDate": "Introduce las fechas como AAAA-MM-DD.",
      "endBeforeStart": "La fecha de fin debe ser posterior a la de inicio.",
      "alreadyEnded": "Ese periodo destacado ya ha terminado.",
      "invalidPriority": "La prioridad debe ser un número entero del 1 al 999.",
      "saveFailed": "No se pudo guardar. Inténtalo de nuevo."
    }
  },
  "map": {
    "loadingMap": "Cargando mapa...",
    "showEvents": "Mostrar eventos",
    "hide": "Ocultar",
    "noMappedEvents": "No hay eventos mapeados cercanos.",
    "noMappedEventsNearby": "No hay eventos mapeados cerca",
    "selectDate": "Seleccionar fecha",
    "selectCity": "Selecciona ciudad",
    "myLocation": "Mi ubicación",
    "locating": "Ubicando…",
    "locationDeniedTitle": "Ubicación denegada",
    "locationDeniedMsg": "Habilite el acceso a la ubicación en Configuración para usar esta función.",
    "locationUnavailableTitle": "Ubicación no disponible",
    "locationUnavailableMsg": "No se pudo obtener tu ubicación. Por favor inténtalo de nuevo.",
    "locationUnavailable": "Ubicación no disponible",
    "locationPermissionDenied": "Permiso de ubicación denegado",
    "locationUnavailableHint": "Activa los servicios de ubicación y vuelve a intentarlo.",
    "locationPermissionDeniedHint": "Permita el acceso a la ubicación en Configuración para usar su posición.",
    "recenterToMyLocation": "Reciente a mi ubicación",
    "invalidSharedLocation": "Esta ubicación no se puede mostrar ahora mismo.",
    "dismissSharedLocation": "Ocultar ubicación compartida"
  },
  "categories": {
    "social": "Redes sociales",
    "adventure": "Aventura",
    "culture": "Cultura",
    "food": "Comida",
    "nightlife": "Vida nocturna"
  },
  "event": {
    "chatNoLongerAvailable": "El chat ya no está disponible",
    "chatNoLongerAvailableBody": "Este chat ya no existe porque el evento ha terminado.",
    "plan": "Plano",
    "communityPlan": "Plan Comunitario",
    "officialEvent": "Evento oficial",
    "clubEvent": "Evento del club",
    "jamSession": "Sesión improvisada",
    "tonight": "Esta noche",
    "interested": "personas interesadas",
    "interestedCount_one": "{count} persona interesada",
    "interestedCount_few": "{count} personas interesadas",
    "interestedCount_many": "{count} personas interesadas",
    "interestedCount_other": "{count} personas interesadas",
    "interestedBtn": "Interesado",
    "members": "miembros",
    "memberCount_one": "{count} miembro",
    "memberCount_few": "{count} miembros",
    "memberCount_many": "{count} miembros",
    "memberCount_other": "{count} miembros",
    "eventChat": "Chat de evento",
    "joiningChat": "Uniéndose…",
    "openVenue": "Lugar abierto",
    "organizer": "Organizador",
    "leavePlan": "Plan de salida",
    "requestSentShort": "Solicitud enviada",
    "openChat": "Abrir Chat",
    "planChat": "Planificar chat",
    "dateTba": "Fecha por confirmar",
    "timeTba": "Hora por confirmar",
    "decline": "Rechazar",
    "accept": "Aceptar",
    "tonyteNight": "Una noche Tonyte a la que vale la pena asistir.",
    "lowRisk": "Riesgo bajo",
    "lowRiskSub": "Plano público o claramente descrito",
    "caution": "Precaución",
    "cautionSub": "Se recomienda cuidado adicional",
    "highRisk": "Alto riesgo",
    "highRiskSub": "Detalles del plan privados o confidenciales",
    "aboutThisPlan": "Acerca de este plan",
    "aboutThisEvent": "Acerca de este evento",
    "detailsFinalized": "Se están ultimando los detalles.",
    "lineup": "Alineación",
    "genres": "Géneros",
    "signInToJoinChats": "Inicia sesión para unirte a los chats del evento.",
    "signInToMarkInterested": "Inicie sesión para marcar eventos como interesados.",
    "signInToJoinPlans": "Inicie sesión para unirse a los planes.",
    "chatUnavailable": "Chat no disponible",
    "noEventChat": "Este evento no incluye un chat de evento.",
    "couldNotJoinChat": "No se pudo unir al chat",
    "removedFromPlan": "Fuiste eliminado de este plan.",
    "requestSent": "¡Solicitud enviada!",
    "organizerWillReview": "El organizador revisará su solicitud.",
    "couldNotSendRequest": "No se pudo enviar la solicitud",
    "leftPlan": "Plano izquierdo",
    "couldNotLeavePlan": "No se pudo abandonar el plan",
    "planDeleted": "Plan eliminado",
    "couldNotDeletePlan": "No se pudo eliminar el plan",
    "couldNotDeleteEvent": "No se pudo eliminar el evento",
    "noDateAvailable": "No hay fecha disponible",
    "noScheduledTime": "Este evento aún no tiene una hora programada.",
    "openingGoogleCalendar": "Abriendo Calendario Google...",
    "confirmCalendarSave": "Confirma allí para guardar el evento.",
    "deleteEventQuestion": "¿Eliminar evento?",
    "deleteEventConfirm": "¿Estás seguro de que deseas eliminar este evento? Esta acción no se puede deshacer.",
    "joinEventChatQuestion": "¿Unirte al chat del evento?",
    "joinEventChatPrompt": "¿Quieres marcar como interesado y unirte al chat del evento?",
    "interestedOnly": "Sólo interesados",
    "joinChat": "Unirse al chat",
    "shareEvent": "Compartir evento",
    "shareOutsideTonyte": "Compartir fuera de Tonyte",
    "sendInTonyteChat": "Enviar en chat Tonyte",
    "foundOnTonyte": "Encontré esto en Tonyte.",
    "openGoogleMaps": "Abrir en Mapas Google",
    "openMaps": "Abrir en Mapas",
    "couldNotOpenMaps": "No se pudieron abrir mapas",
    "couldNotOpenEventLink": "No se pudo abrir el enlace del evento",
    "viewOfficialEvent": "Ver evento oficial",
    "capacity": "Capacidad",
    "dateTime": "Fecha y hora",
    "calendar": "Calendario",
    "addToCalendar": "Agregar al calendario",
    "publishedBy": "Publicado por",
    "openGoogleCalendar": "Abrir Calendario Google",
    "couldNotOpenCalendar": "No se pudo abrir el calendario",
    "location": "Ubicación",
    "exactLocationAfterApproval": "Ubicación exacta compartida en el chat del plan después de la aprobación.",
    "joinRequests": "Solicitudes de unión",
    "couldNotAccept": "No se pudo aceptar",
    "couldNotDecline": "No se pudo rechazar",
    "requestToJoin": "¿Solicitud para unirse?",
    "highRiskWarning": "Este plan puede estar en un entorno privado o confidencial. Por favor tenga especial precaución.",
    "mediumRiskWarning": "Este plan puede involucrar alcohol o vida nocturna. Sea consciente de su entorno.",
    "ackRisks": "Entiendo los riesgos y quiero continuar",
    "messageOrganizerOptional": "Agregar un mensaje al organizador (opcional)",
    "sendRequest": "Enviar solicitud",
    "deleteEventConfirmShort": "¿Estás seguro? Esta acción no se puede deshacer.",
    "requestToJoinFirst": "Solicitud para unirse primero",
    "requestToJoinFirstMsg": "Enviar una solicitud de unión para acceder al chat del plan una vez aceptada.",
    "cancelRequestQuestion": "¿Cancelar solicitud?",
    "cancelRequestMsg": "¿Retirar su solicitud de incorporación a este plan?",
    "keepRequest": "Mantener solicitud",
    "cancelRequest": "Cancelar solicitud",
    "couldNotCancel": "No se pudo cancelar",
    "adminCannotLeave": "Los administradores de planes no pueden abandonar los planes.",
    "deletePlanInstead": "¿Eliminar este plan en su lugar?",
    "deletePlanQuestion": "¿Eliminar plan?",
    "noStay": "No, quédate",
    "yesDeletePlan": "Sí, eliminar plan",
    "venuePost": "Publicación del lugar",
    "hostedBy": "Organizado por",
    "addComment": "Agregar un comentario...",
    "comments": "Comentarios",
    "tonyteUser": "Usuario Tonyte",
    "shareIntro": "Únete a este evento en Tonyte 🎉",
    "couldNotShare": "No se pudo compartir",
    "missingShareableId": "A este evento le falta un identificador para compartir.",
    "nativeShareUnavailable": "La hoja para compartir nativa no está disponible en este momento.",
    "missingExternalLink": "Este evento aún no incluye un enlace.",
    "couldNotUpdateInterest": "No se pudo actualizar el interés",
    "eventsCount_one": "{count} evento",
    "eventsCount_few": "{count} eventos",
    "eventsCount_many": "{count} eventos",
    "eventsCount_other": "{count} eventos",
    "joinedCount_one": "{count} se unió",
    "joinedCount_few": "{count} se unieron",
    "joinedCount_many": "{count} se unieron",
    "joinedCount_other": "{count} se unieron"
  },
  "plans": {
    "myPlans": "Mis planes",
    "communityPlans": "Planes comunitarios",
    "communityPlansSubtitle": "Únete a aventuras grupales cerca de ti",
    "communityPlanBadge": "PLAN COMUNITARIO",
    "freeBadge": "GRATIS",
    "postedBy": "Publicado por",
    "member": "miembro",
    "open": "Abrir",
    "leave": "Salir",
    "request": "Solicitud",
    "loading": "Cargando planos...",
    "noneYet": "Aún no hay planes comunitarios",
    "noneYetSubtitle": "Crea un plan para conocer gente nueva y explorar juntos.",
    "createPlan": "Crear plan",
    "completeProfile": "Completa tu perfil para ver planos",
    "addRealProfilePicture": "Añade una foto de perfil real",
    "completeProfileSubtitle": "Se requiere una foto de perfil real antes de poder unirte o crear planes comunitarios.",
    "signInTitle": "Inicia sesión para ver los planes",
    "signInSubtitle": "Crea una cuenta para unirte y organizar aventuras grupales.",
    "signInRequiredSubtitle": "Debes iniciar sesión para unirte a los planes.",
    "leaveFailed": "No se pudo abandonar el plan. Por favor inténtalo de nuevo.",
    "planDeleted": "Plan eliminado",
    "removed": "ha sido eliminado.",
    "deleteFailed": "No se pudo eliminar el plan. Por favor inténtalo de nuevo.",
    "requestSent": "¡Solicitud enviada!",
    "requestSentSubtitle": "El organizador del plan revisará su solicitud.",
    "requestFailed": "No se pudo enviar su solicitud. Por favor inténtalo de nuevo.",
    "deletePlan": "Eliminar plan",
    "deletePlanConfirmPrefix": "Eliminar",
    "deletePlanConfirmSuffix": "permanentemente? Esto no se puede deshacer.",
    "templatesTitle": "¿Necesitas una idea?",
    "templatesSubtitle": "Elige un plan y hazlo tuyo."
  },
  "share": {
    "sentToChats": "Enviado a {count} chat",
    "sentToChatsCount_one": "Enviado a {count} chat",
    "sentToChatsCount_few": "Enviado a {count} chats",
    "sentToChatsCount_many": "Enviado a {count} chats",
    "sentToChatsCount_other": "Enviado a {count} chats",
    "couldNotSend": "No se pudo enviar. Por favor inténtalo de nuevo."
  },
  "forms": {
    "searchAddressOrVenue": "Buscar dirección o lugar..."
  },
  "completeProfile": {
    "couldNotSave": "No se pudo guardar. Intentar otra vez.",
    "couldNotUploadCover": "No se pudo cargar la foto de portada.",
    "couldNotUploadProfilePhoto": "No se pudo cargar la foto de perfil.",
    "doneTitle": "¡Perfil mejorado!",
    "complete": "Completo",
    "doneSub": "Tu perfil ahora es más visible. Mejores recomendaciones, coincidencias más inteligentes y eventos más relevantes en camino.",
    "backToProfile": "Volver al perfil",
    "profileBoost": "AUMENTO DE PERFIL",
    "enhanceExperience": "Mejora tu experiencia",
    "addProfilePicture": "Agregar una foto de perfil",
    "addProfilePictureSub": "Una foto real ayuda a que las personas te reconozcan en vibes, chats y planes.",
    "uploadPhoto": "Subir foto",
    "keepCurrent": "Mantener actualizado",
    "skipStep": "Omita este paso",
    "dobTitle": "Tu fecha de nacimiento",
    "dobSub": "Esto solo se puede configurar una vez y mantiene Tonyte apropiado para la edad.",
    "dobPlaceholder": "Seleccionar día, mes, año",
    "chooseDob": "Elige tu fecha de nacimiento para continuar.",
    "underMinAge": "Tonyte es para viajeros mayores de 16 años.",
    "saveContinue": "Guardar y continuar",
    "interestsTitle": "¿En qué te gusta?",
    "interestsSub": "Elija al menos 3 para que Tonyte pueda ajustar sus recomendaciones.",
    "selected": "seleccionado",
    "pickInterests": "Elija al menos 3 intereses.",
    "locationTitle": "¿Dónde estás?",
    "locationSub": "Tu ciudad base ayuda a Tonyte a mantener la relevancia de las personas y los planes.",
    "city": "Ciudad",
    "country": "País",
    "addBaseCity": "Agrega tu ciudad base para continuar.",
    "bioTitle": "Cuenta tu historia",
    "bioSub": "Una breve biografía ayuda a los demás a saber con quién se encontrarán.",
    "bioPlaceholder": "Escribe algo sobre ti: lo que te gusta, lo que amas, qué te hace salir...",
    "coverTitle": "Agregar una foto de portada",
    "coverSub": "Una excelente portada hace que tu perfil se destaque en Discover.",
    "tapChooseCover": "Toca para elegir la portada",
    "uploadCover": "Subir portada",
    "vibeTitle": "¿Cuál es tu vibe?",
    "vibeSub": "Su personalidad viajera nos ayuda a recomendar los eventos y las personas adecuadas.",
    "musicTitle": "Tu gusto musical",
    "musicSub": "Encontraremos eventos que coincidan con la música que te gusta. Recoge hasta 5.",
    "languagesTitle": "Idiomas que hablas",
    "languagesSub": "Encuentra viajeros con los que realmente puedas hablar. Elija todo lo que corresponda.",
    "goingOutTitle": "Estilo de salida",
    "goingOutSub": "¿Qué tipo de noches disfrutas? Elija todo lo que corresponda.",
    "saveFinish": "Guardar y finalizar",
    "saveExit": "Guardar y salir",
    "socialVibeButterfly": "Mariposa social",
    "socialVibeButterflyDesc": "Te gusta conocer gente nueva.",
    "socialVibeAdventurer": "Aventurero",
    "socialVibeAdventurerDesc": "Buscas emociones y lugares nuevos.",
    "socialVibeFoodie": "Amante de la gastronomía",
    "socialVibeFoodieDesc": "La comida es tu lenguaje de amor.",
    "socialVibeNightlife": "Amante de la vida nocturna",
    "socialVibeNightlifeDesc": "Las mejores horas son después de la medianoche.",
    "socialVibeCulture": "Cazador de cultura",
    "socialVibeCultureDesc": "Museos, arte, historia, todo ello.",
    "socialVibeChill": "Tranquilo y relajado",
    "socialVibeChillDesc": "Viaje lento, bueno vibes.",
    "music_techno": "Tecno",
    "music_house": "Casa",
    "music_hipHop": "Hip Hop",
    "music_rAndB": "R&B",
    "music_pop": "Popular",
    "music_rock": "Roca",
    "music_indie": "Independiente",
    "music_edm": "Electroerosión",
    "music_jazz": "Jazz",
    "music_classical": "Clásica",
    "music_reggaeton": "Reggaetón",
    "music_afrobeats": "Afrobeats",
    "music_loFi": "Lo-Fi",
    "music_drumBass": "Batería y bajo",
    "music_ambient": "Ambiente",
    "spoken_english": "Inglés",
    "spoken_german": "Alemán",
    "spoken_french": "Francés",
    "spoken_spanish": "Español",
    "spoken_italian": "italiano",
    "spoken_portuguese": "Portugués",
    "spoken_dutch": "Holandés",
    "spoken_polish": "Polaco",
    "spoken_czech": "checo",
    "spoken_romanian": "rumano",
    "spoken_greek": "Griego",
    "spoken_hungarian": "húngaro",
    "spoken_swedish": "sueco",
    "spoken_danish": "danés",
    "spoken_finnish": "Finlandés",
    "spoken_hindi": "hindi",
    "spoken_ukrainian": "Ucraniano",
    "spoken_russian": "Ruso",
    "spoken_arabic": "Árabe",
    "spoken_chinese": "Chino",
    "spoken_japanese": "japonés",
    "goingOutClubs": "Discotecas y fiestas",
    "goingOutBars": "Bares y pubs",
    "goingOutRooftops": "Azoteas y Terrazas",
    "goingOutLiveMusic": "Música en vivo",
    "goingOutChill": "Lugares fríos",
    "goingOutStreetFood": "Comida callejera y mercados"
  },
  "profile": {
    "myVenueProfile": "Mi perfil de socio",
    "myVenueProfileSub": "Mira tu local como lo ven los visitantes",
    "basedIn": "Con sede en",
    "locationNotAdded": "Ubicación no agregada",
    "addBio": "Agrega algo sobre ti",
    "recently": "Recientemente",
    "events": "Eventos",
    "plans": "Planes",
    "interests": "Intereses",
    "attended": "Asistió",
    "created": "Creado",
    "saved": "Guardado",
    "memberSince": "Miembro desde",
    "exploringSince": "Con Tonyte desde entonces.",
    "tapToChangeCity": "Cambiar feed y ciudad del mapa",
    "viewAll": "Ver todo",
    "addInterest": "Agregar interés",
    "uploadEvent": "Subir evento",
    "signOut": "Cerrar sesión",
    "signOutConfirm": "¿Estás seguro de que deseas cerrar sesión?",
    "cancel": "Cancelar",
    "createAccountOrSignIn": "Crear cuenta o iniciar sesión",
    "logOut": "Cerrar sesión",
    "personality": "Personalidad",
    "editProfile": "Editar perfil",
    "shareProfile": "Compartir perfil",
    "qrCode": "Código QR",
    "verifications": "Verificaciones",
    "vibeVerified": "Vibe Verificado",
    "studentVerified": "Estudiante verificado",
    "earlyMember": "Miembro temprano",
    "topPlanner": "Planificador superior",
    "eventHost": "Anfitrión del evento",
    "aura": "Aura",
    "myPlans": "Mis planes",
    "loadingPlans": "Cargando planos...",
    "upcomingPlansEmpty": "Tus próximos planes aparecerán aquí.",
    "createPlan": "Crear plan",
    "upcomingEvents": "Próximos eventos",
    "loadingEvents": "Cargando eventos...",
    "upcomingEventsEmpty": "Aún no hay eventos próximos.",
    "interestedEvents": "Eventos interesados",
    "loadingInterestedEvents": "Cargando eventos interesados...",
    "interestedEventsEmpty": "Los eventos que marques como interesados aparecerán aquí.",
    "browseEvents": "Explorar eventos",
    "badgesAchievements": "Insignias y logros",
    "savedTemplates": "Plantillas guardadas",
    "reusableEventDrafts": "Borradores de eventos reutilizables",
    "uploadedPlans": "Planes cargados",
    "yourCreatedPlans": "Tus planes creados",
    "planRequests": "Solicitudes de planes",
    "pendingPlanRequests": "Solicitudes de unión pendientes para tus planes",
    "todaysVibe": "Vibe de hoy",
    "todaysVibePrompt": "Descubre tu vibe",
    "todaysVibePromptSub": "Responde unas preguntas rápidas",
    "loadingVibeMatches": "Cargando coincidencias vibe...",
    "vibeMatchWaiting": "vibe partido en espera",
    "vibeMatchesWaiting": "conexiones vibe esperando",
    "vibeMatchWaitingCount_one": "{count} conexión vibe esperando",
    "vibeMatchWaitingCount_few": "{count} conexiones vibe esperando",
    "vibeMatchWaitingCount_many": "{count} conexiones vibe esperando",
    "vibeMatchWaitingCount_other": "{count} conexiones vibe esperando",
    "following": "Siguiendo",
    "followingSearch": "Busca socios que sigues",
    "followingEmpty": "Aún no sigues a ningún socio. Encuéntralos en Vibe at Venues.",
    "followingNoMatch": "Ningún socio coincide con tu búsqueda.",
    "followingCount_one": "{count} socio",
    "followingCount_few": "{count} socios",
    "followingCount_many": "{count} socios",
    "followingCount_other": "{count} socios",
    "studiZoneOpen": "Abrir",
    "studiZonePending": "Pendiente",
    "studiZoneVerify": "Verifícate",
    "updateRole": "¿Actualizar rol de usuario?",
    "changeRole": "¿Cambiar el rol de {name} de {from} a {to}?",
    "updateRoleAction": "Actualizar rol",
    "noRolePermission": "No tienes permiso para actualizar este rol.",
    "coAdminRoleRestriction": "Los coadministradores no pueden asignar ni modificar cuentas de administrador/coadministrador.",
    "adminSignInRequired": "Debes iniciar sesión como administrador para actualizar roles.",
    "roleUpdateFailed": "No se puede actualizar el rol en este momento.",
    "roleUpdated": "Rol de usuario actualizado.",
    "uploadingProfile": "Subiendo foto de perfil…",
    "uploadingCover": "Subiendo foto de portada…",
    "profileSaved": "Foto de perfil guardada.",
    "coverSaved": "Foto de portada guardada.",
    "imageUpdateFailed": "No se pudo actualizar la imagen",
    "removeProfilePhoto": "¿Quitar foto de perfil?",
    "removeCoverPhoto": "¿Quitar foto de portada?",
    "restoreDefault": "Esto restaurará la imagen predeterminada.",
    "remove": "Eliminar",
    "imageRemoveFailed": "No se pudo eliminar la imagen",
    "interestsSaveFailed": "No se pudieron guardar los intereses",
    "notificationsSaveFailed": "No se pudieron guardar las notificaciones",
    "reviewFailed": "No se pudo revisar la solicitud",
    "unchanged": "Inténtalo de nuevo: no se modificó nada.",
    "revokeFailed": "No se pudo revocar la insignia", "revokeSuccessTitle": "Vibe Verified revocado", "revokeSuccessBody": "Se ha eliminado la insignia Vibe Verified de este usuario.",
    "shareFailed": "No se pudo compartir",
    "missingShareId": "A este perfil le falta una identificación que se pueda compartir.",
    "shareUnavailable": "La hoja para compartir nativa no está disponible en este momento.",
    "qrUnavailable": "QR no disponible",
    "vibesHub": "Vibes",
    "vibesHubSub": "Tu chat personal y conexiones vibe",
    "admin": "Administrador",
    "userManagement": "Gestión de usuarios",
    "usersCount": "Usuarios de {count}",
    "adminHelp": "Administre roles Tonyte para usuarios, evaluadores, organizadores, lugares, coadministradores y administradores.",
    "userManagementSub": "Buscar usuarios y asignar roles.",
    "studentVerifications": "Verificaciones de estudiantes",
    "faceVerificationRequests": "Solicitudes de verificación facial",
    "pendingReviewCount": "{count} pendiente de revisión",
    "loading": "Cargando…",
    "change": "Cambiar",
    "close": "Cerrar",
    "myQrCode": "Mi código QR",
    "share": "Compartir",
    "coverPhoto": "Foto de portada",
    "viewCover": "Ver portada",
    "changeCover": "Cambiar portada",
    "removeCover": "Quitar cubierta",
    "pendingReviewCount_one": "{count} pendiente de revisión",
    "pendingReviewCount_few": "{count} revisiones pendientes",
    "pendingReviewCount_many": "{count} revisiones pendientes",
    "pendingReviewCount_other": "{count} revisiones pendientes",
    "tonyteTraveler": "Tonyte Viajero",
    "blockedAccountsLoadFailed": "No se pudieron cargar cuentas bloqueadas en este momento.",
    "unblockFailed": "No se pudo desbloquear esta cuenta en este momento.",
    "noConnectedEmail": "No hay ningún correo electrónico conectado a esta cuenta.",
    "passwordResetSent": "Enlace de restablecimiento de contraseña enviado a {email}.",
    "passwordResetFailed": "No se pudo enviar el correo electrónico de restablecimiento en este momento.",
    "enterValidStudentEmail": "Ingrese una dirección de correo electrónico de estudiante válida.",
    "studentVerificationEmailSent": "¡Correo electrónico de verificación enviado! Revisa la bandeja de entrada de tu universidad y haz clic en el enlace para confirmar.",
    "studentVerificationEmailFailed": "No se pudo enviar el correo electrónico de verificación. Por favor inténtalo de nuevo.",
    "feedbackMessageRequired": "Ingrese un mensaje de comentarios.",
    "feedbackTypeRequired": "Elija un tipo de comentario.",
    "feedbackThanks": "Gracias, comentarios enviados.",
    "feedbackSaveFailed": "No se pudieron guardar los comentarios. Por favor inténtalo de nuevo.",
    "feedbackType_general": "Generalidades",
    "feedbackType_bug": "Error",
    "feedbackType_feature": "Solicitud de función",
    "feedbackType_event_issue": "Problema del evento",
    "noSignedInUser": "No se encontró ningún usuario registrado.",
    "missingEmailForConfirmation": "A su cuenta le falta una dirección de correo electrónico para confirmar la contraseña.",
    "enterPasswordToContinue": "Por favor ingresa tu contraseña para continuar.",
    "googleReauthUnavailable": "La reautenticación de Google no está disponible en esta compilación.",
    "googleMissingIdToken": "La reautenticación de Google no devolvió un token de identificación.",
    "appleReauthUnavailable": "La reautenticación de Apple no está disponible en este dispositivo.",
    "appleMissingIdentityToken": "La reautenticación de Apple no devolvió un token de identidad.",
    "deleteRequiresRecentLogin": "Inicie sesión nuevamente para confirmar la eliminación de la cuenta.",
    "deleteInvalidCredential": "Esa contraseña o credencial de inicio de sesión no fue aceptada. Por favor inténtalo de nuevo.",
    "deleteUserMismatch": "Vuelva a autenticarse con la misma cuenta que actualmente inició sesión en Tonyte.",
    "deleteReauthInterrupted": "Se interrumpió la reautenticación. Por favor inténtalo de nuevo.",
    "deleteNetworkError": "Error de red. Comprueba tu conexión y vuelve a intentarlo.",
    "deletePermissionDenied": "Permiso denegado. Inicie sesión nuevamente e inténtelo una vez más.",
    "deleteFailedAtStage": "Error al eliminar cuenta en {stage}: {error}",
    "deleteUnavailable": "No se pudo eliminar tu cuenta en este momento.",
    "signInAgainBeforeDelete": "Inicie sesión nuevamente antes de eliminar su cuenta.",
    "mustSignInToDelete": "Debes iniciar sesión para eliminar tu cuenta.",
    "accountCleanupFailed": "La solicitud HTTP de limpieza de cuenta falló.",
    "selfieUnclear": "La selfie es demasiado pequeña o poco clara. Vuelva a tomarlo con buena luz y con la cara y los gestos visibles.",
    "selfieRequired": "Tómate tu selfie de verificación antes de enviarlo.",
    "verificationSyncPending": "Verificación enviada. Sincronización de estado pendiente.",
    "verificationReviewFailed": "La revisión de verificación falló.",
    "vibeVerifiedApproved": "Aprobado Vibe Verificado para {user}.",
    "verificationClearSelfieFailed": "La verificación falló. Inténtalo de nuevo con una selfie clara.",
    "revokeNotConfirmed": "Revocar no confirmó el éxito.",
    "shareTitle": "Perfil Tonyte",
    "shareMessage": "Mira mi perfil Tonyte:\n{url}",
    "acceptSaveDomain": "Aceptar + Guardar Dominio",
    "tonyteUser": "Usuario Tonyte",
    "verificationEmailSentTitle": "Correo electrónico de verificación enviado",
    "verificationPendingTitle": "Verificación Pendiente",
    "verificationFailedTitle": "Verificación fallida",
    "studentVerificationTitle": "Verificación de Estudiante",
    "verificationCheckInboxBody": "Por favor revisa tu bandeja de entrada y confirma que este correo electrónico te pertenece.",
    "verificationReviewingBody": "Estamos revisando tu estado de estudiante.",
    "verificationFailedBody": "No pudimos verificar tu condición de estudiante. Por favor revise el correo electrónico de su estudiante o inténtelo nuevamente.",
    "verificationUnlockBody": "Desbloquea eventos para estudiantes, reuniones Erasmus, vida nocturna en el campus, eventos, planes y chats solo para estudiantes.",
    "studiZoneUnderConstruction": "StudiZone en construcción",
    "enterStudiZone": "Ingrese StudiZone",
    "verifyStudentStatus": "Verificar el estado del estudiante",
    "faq1Question": "¿Qué es Tonyte?",
    "faq1Answer": "Tonyte te ayuda a eventos discover, unirte a planes y conocer gente cercana mientras viajas o vives en una ciudad.",
    "faq2Question": "¿Tonyte es gratuito?",
    "faq2Answer": "Sí, las funciones principales como descubrir eventos, unirse a planes y chatear son gratuitas.",
    "faq3Question": "¿Quién puede ver mi perfil?",
    "faq3Answer": "Los usuarios pueden ver tu perfil cuando interactúas con ellos a través de chats, planes, eventos o enlaces de perfil compartido.",
    "faq4Question": "¿Qué es un plan?",
    "faq4Answer": "Un plan es una reunión informal creada por un usuario, como un café, una barbacoa, visitas turísticas, juegos o salir.",
    "faq5Question": "¿Quién puede crear planes?",
    "faq5Answer": "Cualquier usuario que haya iniciado sesión puede crear un plan comunitario.",
    "faq6Question": "¿Qué sucede cuando me uno a un plan?",
    "faq6Answer": "Es posible que lo agreguen a la lista de asistentes del plan y obtenga acceso al chat del plan.",
    "faq7Question": "¿Puedo dejar un plan?",
    "faq7Answer": "Sí, los participantes normales pueden abandonar un plan. Los organizadores no pueden abandonar su propio plan a menos que lo eliminen.",
    "faq8Question": "¿Puede un organizador eliminarme de un plan?",
    "faq8Answer": "Sí. Los organizadores pueden eliminar personas de sus propios planes para gestionar la seguridad y la comodidad.",
    "faq9Question": "¿Qué sucede si me eliminan de un plan?",
    "faq9Answer": "No puedes volver a unirte a ese plan, pero aún puedes ver el chat e informar el plan o usuarios específicos si es necesario.",
    "faq10Question": "¿Quién puede enviarme un mensaje?",
    "faq10Answer": "Las personas pueden enviarte mensajes a través de coincidencias, chats de eventos o chats de planes.",
    "faq11Question": "¿Por qué no puedo enviar mensajes en un chat?",
    "faq11Answer": "Es posible que ya no seas un participante activo o que hayas sido eliminado de ese plan/chat.",
    "faq12Question": "¿Puedo denunciar a alguien?",
    "faq12Answer": "Sí. Puedes denunciar usuarios, planes, eventos o comportamientos de chat si algo te parece inseguro, abusivo, discriminatorio o inapropiado.",
    "faq13Question": "¿Es visible mi ubicación exacta?",
    "faq13Answer": "No. La ubicación se utiliza para mostrar eventos y planes cercanos. Su ubicación exacta en vivo no se muestra a otros usuarios.",
    "faq14Question": "¿Puedo editar mi perfil?",
    "faq14Answer": "Sí. Puede actualizar su nombre, ciudad, biografía, fotos e intereses en cualquier momento.",
    "faq15Question": "¿Cómo elimino mi cuenta?",
    "faq15Answer": "Vaya a Configuración de perfil → Eliminar cuenta.",
    "faq16Question": "La aplicación no funciona correctamente. ¿Qué tengo que hacer?",
    "faq16Answer": "Utilice Ayuda y comentarios dentro de Configuración y describa el problema."
  },
  "vibes": {
    "synchronize": "Sincronizar",
    "lockInToday": "Bloquea el vibe de hoy",
    "getYourVibesSynchronized": "Sincroniza tu Vibes",
    "getYourVibesSynchronizedFlat": "Sincroniza tu vibes",
    "vibeCircle": "Círculo Vibe",
    "vibeAlignment": "Alineación Vibe",
    "sharedFrequency": "Frecuencia compartida",
    "instantSync": "Sincronización instantánea",
    "strongSync": "Sincronización fuerte",
    "recommendedVibe": "Recomendado Vibe",
    "openChat": "Abrir chat",
    "continueChat": "Continuar chateando",
    "sendVibe": "Enviar vibe",
    "startSync": "Iniciar sincronización",
    "pickAllHint": "Elige todo lo que se ajuste a tu vibe ahora mismo.",
    "dontOverthink": "No lo pienses demasiado.",
    "pickUpTo": "Recoger hasta",
    "couldNotSaveVibe": "No se pudo guardar",
    "couldNotSaveVibeSub": "Aún no se pudo guardar tu vibe. Por favor inténtalo de nuevo.",
    "icebreakersReady": "Dos preguntas para romper el hielo están listas en tu chat.",
    "suggestedIcebreaker": "Rompehielos sugerido",
    "signalLocked": "señal bloqueada",
    "signalsLocked": "señales fijadas",
    "signalLockedCount_one": "{count} señal fijada",
    "signalLockedCount_few": "{count} señales fijadas",
    "signalLockedCount_many": "{count} señales fijadas",
    "signalLockedCount_other": "{count} señales fijadas",
    "chooseOneSignal": "Elige una señal",
    "chooseUpTo": "Elige hasta",
    "next": "Siguiente",
    "microcopy0": "No lo pienses demasiado.",
    "microcopy1": "Ve con la energía de hoy.",
    "microcopy2": "Esto puede cambiar mañana.",
    "microcopy3": "Actual vibe únicamente.",
    "microcopy4": "Sea honesto.",
    "microcopy5": "El primer instinto suele ser el correcto.",
    "dayVibesBadge": "DÍA VIBES",
    "questionOf": "Pregunta",
    "resultsUnlock1pm": "Desbloqueo de resultados a las 1:00 PM",
    "lastOne": "¡El último!",
    "questionsLeft": "quedan preguntas",
    "questionLeft": "pregunta restante",
    "questionLeftCount_one": "Queda {count} pregunta",
    "questionLeftCount_few": "Quedan {count} preguntas",
    "questionLeftCount_many": "Quedan {count} preguntas",
    "questionLeftCount_other": "Quedan {count} preguntas",
    "openAt6am": "El escaneo aura de hoy se abre a las 6:00 AM.",
    "resetDaily": "Nuevas preguntas y resultados del Círculo Vibe se reinician con el nuevo día.",
    "loadingAura": "Cargando el aura de hoy...",
    "noAuraToday": "No se encontró aura para hoy.",
    "goBack": "Volver atrás",
    "todaysAura": "Aura de hoy",
    "todayYouAre": "HOY ERES",
    "resultsIn": "Resultados en",
    "basedOnToday": "Basado en el día de hoy Vibes",
    "findingWavelength": "Encontrar personas en tu longitud de onda...",
    "noAlignmentYet": "Aún no hay alineación Vibe",
    "noAlignmentSubtitle": "Todavía nadie en tu onda ha terminado el juego de hoy. Pueden llegar nuevos matches a medida que otros jueguen; aparecerán aquí automáticamente.",
    "firstVibesUnlock": "¡Ya estás dentro! Tus primeras vibes se desbloquean a las 13:00.",
    "moreMatchesLater": "Pueden llegar más matches a medida que se una más gente; tu Círculo Vibe se actualiza todo el día.",
    "matchingInProgress": "Buscando tus vibes…",
    "matchingInProgressBody": "Estamos comparándote con todos los que han jugado hoy. Se actualiza solo.",
    "matchingRetryingBody": "Está tardando un poco más de lo normal; seguimos en ello. Tus vibes aparecerán aquí automáticamente.",
    "moreCanArrive": "Pueden llegar más vibes a medida que otros terminen el juego de hoy.",
    "resultsRightAway": "Resultados justo al terminar",
    "refresh": "Actualizar",
    "sync": "sincronización",
    "sharedFrequencyToday": "frecuencia compartida hoy",
    "sharedFrequenciesToday": "frecuencias compartidas hoy",
    "alignmentPercentPrefix": "Su alineación vibe es",
    "icebreakerPrompt1": "¿A qué dirían realmente que sí ambos hoy?",
    "icebreakerPrompt2": "¿Qué configuración haría que tu vibe compartido se sintiera fácil?",
    "auraCitySoulName": "Alma de la ciudad",
    "auraCitySoulDescription": "Hoy estás dando energía curiosa, cinematográfica y silenciosamente aventurera.",
    "auraCitySoulTrait1": "Explorador de la ciudad",
    "auraCitySoulTrait2": "Sociales suaves",
    "auraCitySoulTrait3": "Estado de ánimo estético",
    "auraSoftChaosName": "Caos suave",
    "auraSoftChaosDescription": "Planes espontáneos, chispas sociales y energía bellamente desestructurada.",
    "auraSoftChaosTrait1": "Espontáneo",
    "auraSoftChaosTrait2": "Café Tolva",
    "auraSoftChaosTrait3": "Social hoy",
    "auraGoldenHourName": "Hora Dorada",
    "auraGoldenHourDescription": "Cálido, sin prisas y resplandeciente con presencia intencional hoy.",
    "auraGoldenHourTrait1": "Intencional",
    "auraGoldenHourTrait2": "Buscador de calidez",
    "auraGoldenHourTrait3": "Momento presente",
    "auraNeonWolfName": "Lobo de neón",
    "auraNeonWolfDescription": "Hoy en día, es atrevido, cargado y funciona con energía eléctrica independiente.",
    "auraNeonWolfTrait1": "Independiente",
    "auraNeonWolfTrait2": "Eléctricamente Negrita",
    "auraNeonWolfTrait3": "Listo para la noche",
    "auraQuietStormName": "Tormenta silenciosa",
    "auraQuietStormDescription": "Profundamente presente, creativamente vivo y silenciosamente poderoso hoy.",
    "auraQuietStormTrait1": "Introspectivo",
    "auraQuietStormTrait2": "Impulsado creativamente",
    "auraQuietStormTrait3": "Profundamente consciente",
    "auraSolarBurstName": "Explosión solar",
    "auraSolarBurstDescription": "Radiante, magnético y rebosante de energía hacia el exterior hoy.",
    "auraSolarBurstTrait1": "Alta energía",
    "auraSolarBurstTrait2": "Radiantemente Abierto",
    "auraSolarBurstTrait3": "Magnéticamente Social",
    "reset": "Restablecer",
    "scan": "Escanear",
    "auraBadgeAccessibility": "Insignia {name} aura",
    "auraBadgeHint": "Amplía la descripción de aura de hoy."
  },
  "venues": {
    "vibeAtVenues": "Vibe en Lugares"
  },
  "imageCrop": {
    "profilePhoto": "Foto de perfil",
    "eventPhoto": "Foto del evento",
    "coverPhoto": "Foto de portada",
    "frameProfile": "Ajusta tu foto de perfil",
    "frameEvent": "Ajusta la foto del evento",
    "frameCover": "Ajusta tu foto de portada",
    "previewBeforeSaving": "Revisa la imagen antes de guardarla.",
    "dragToReposition": "Arrastra la foto para recolocarla",
    "fitEntireImage": "Ajustar imagen completa",
    "cropToFill": "Recortar para llenar",
    "completeImageHint": "Se guardará la imagen completa",
    "viewFullImage": "Ver imagen completa del evento",
    "zoom": "Zoom",
    "cropping": "Recortando...",
    "useImage": "Usar imagen"
  },
  "appUpdate": {
    "defaultTitle": "Tonyte acaba de mejorar",
    "defaultMessage": "Hemos mejorado los mapas, planes, perfiles y la experiencia general de la app.",
    "newVersion": "Nueva versión disponible",
    "newVersionNamed": "Nueva versión {version} disponible",
    "opening": "Abriendo...",
    "updateNow": "Actualizar ahora",
    "optionalTitle": "Actualiza Tonyte 🧡",
    "optionalMessage": "Hay una versión más reciente con las últimas funciones, correcciones y mejoras.",
    "requiredTitle": "Tonyte necesita una actualización",
    "requiredMessage": "Actualiza Tonyte para seguir usando la app.",
    "updateTonyte": "Actualizar Tonyte",
    "notNow": "Ahora no"
  },
  "languages": {
    "en": "Inglés",
    "de": "Alemán",
    "es": "Español",
    "fr": "Francés",
    "ru": "Ruso"
  },
  "onboarding": {
    "languageTitle": "Elige tu idioma",
    "languageSub": "A partir de ahora, Tonyte hablará en tu idioma. Puedes cambiarlo en cualquier momento desde Configuración.",
    "travelerProfile": "Tu perfil de viajero",
    "displayNameTitle": "¿Cómo deberían llamarte los viajeros?",
    "displayNameSub": "Elige un nombre que te parezca.",
    "displayNameLabel": "NOMBRE PARA MOSTRAR",
    "displayNamePlaceholder": "Su nombre para mostrar",
    "changeLater": "Puedes cambiar esto más tarde.",
    "continue": "Continuar",
    "photoTitle": "Agrega una cara a tu perfil",
    "photoSub": "Una imagen de perfil ayuda a otros a reconocer con quién se están reuniendo.",
    "tapUpload": "Toque para cargar",
    "addPhoto": "Agregar foto de perfil",
    "skipNow": "Saltar por ahora",
    "dobTitle": "¿Cuál es tu fecha de nacimiento?",
    "dobSub": "Esto ayuda a Tonyte a mantener los planes y los descubrimientos apropiados para la edad.",
    "dobLabel": "FECHA DE NACIMIENTO",
    "invalidDob": "Por favor elija una fecha de nacimiento válida.",
    "dobReady": "Fecha de nacimiento añadida. Ya puedes continuar.",
    "continueLocked": "Continuar · fecha requerida",
    "interests": "Intereses",
    "selected20": "{count}/20 seleccionado",
    "unlockStudiZone": "Desbloquear StudiZone",
    "unlockStudiZoneSub": "Verifica tu estado de estudiante para acceder a eventos exclusivos para estudiantes, planes Erasmus, comunidades del campus y chats privados para estudiantes.",
    "campusEvents": "Eventos en el campus",
    "erasmusPlans": "Planos Erasmus",
    "studentChats": "Chats de estudiantes",
    "verifiedGuestlist": "Lista de invitados verificada",
    "universityEmail": "CORREO ELECTRÓNICO UNIVERSITARIO",
    "universityEmailPlaceholder": "your@university.edu",
    "universityEmailHelp": "Ingrese el correo electrónico de su universidad para revisión del administrador. Nada de spam, nunca.",
    "submitVerification": "Enviar para verificación",
    "skipVerification": "Omitir por ahora - verificar más tarde desde el perfil",
    "guidelinesTitle": "Normas de la comunidad",
    "guidelinesSub": "Tonyte se basa en la confianza y el respeto. Lea y acepte antes de unirse.",
    "guidelineRespect": "Trate a todos los viajeros con respeto, en línea y en persona.",
    "guidelineHarassment": "Tolerancia cero ante el acoso, el discurso de odio o el abuso.",
    "guidelineRealEvents": "Publica únicamente eventos y planes reales y precisos.",
    "guidelineSafety": "Priorizar la seguridad en todos los arreglos de reuniones.",
    "guidelineData": "Tus datos están protegidos. No vendemos su información.",
    "guidelineReport": "Reporta contenido dañino usando el botón de bandera en la aplicación.",
    "viewTerms": "Ver Términos de Servicio",
    "viewPrivacy": "Ver Política de Privacidad",
    "agreeTerms": "Acepto los Términos de servicio y las pautas de la comunidad",
    "enterTonyte": "Ingrese Tonyte →",
    "skipPhotoTitle": "¿Saltar foto de perfil?",
    "skipPhotoBody": "Sin una foto de perfil, es posible que no puedas acceder a todas las funciones, como Discover, unirte a planes o crear planes.",
    "uploadPicture": "Subir imagen",
    "skipAnyway": "Saltar de todos modos",
    "displayNameMin": "El nombre para mostrar debe tener al menos 2 caracteres.",
    "displayNameSaveFailed": "No se pudo guardar el nombre para mostrar.",
    "choosePhoto": "Elige una foto de perfil u omite por ahora.",
    "photoSaveFailed": "No se pudo guardar la foto de perfil.",
    "photoSkipFailed": "No se pudo omitir la foto de perfil.",
    "dobRequired": "Ingresa tu fecha de nacimiento para continuar.",
    "ageRequirement": "Tonyte es para viajeros de edades {age} y mayores. Por favor verifique su fecha de nacimiento.",
    "profileSaveFailed": "No se pudo guardar el perfil.",
    "verificationSendFailed": "No se pudo enviar el correo electrónico de verificación. Verifique la dirección e inténtelo nuevamente.",
    "skipFailed": "No se pudo omitir.",
    "acceptTerms": "Acepte los Términos y pautas de la comunidad para continuar.",
    "setupFailed": "No se pudo completar la configuración.",
    "themeKicker": "HAZ TONYTE TUYO",
    "themeTitle": "Elige tu estilo",
    "themeSubtitle": "Elige el lado de Tonyte que más se parece a ti.",
    "themeDaylight": "LUZ DEL DÍA",
    "themeDaylightDescriptor": "Luminoso · Cálido · Social",
    "themeMidnight": "MEDIANOCHE",
    "themeMidnightDescriptor": "Oscuro · Atrevido · Eléctrico",
    "themeSwitchAnytime": "Puedes cambiarlo cuando quieras desde tu Perfil.",
    "themeNotPermanent": "No es permanente — cámbialo cuando quieras desde tu Perfil.",
    "themeEnter": "Entrar en Tonyte",
    "selectThemeRequired": "Elige Luz del día o Medianoche para entrar en Tonyte."
  },
  "library": {
    "myPosts": "Mis publicaciones",
    "profileEyebrow": "PERFIL",
    "events": "eventos",
    "plans": "planes",
    "search": "Búsqueda por título, lugar, ciudad, etiquetas…",
    "loadingPosts": "Cargando publicaciones…",
    "edit": "Editar",
    "repost": "Volver a publicar",
    "planEditing": "Edición de planos",
    "planEditingUnavailable": "La edición del plan aún no está disponible.",
    "permissionRequired": "Se requiere permiso",
    "deletePermission": "Solo el organizador del evento o los administradores pueden eliminar esta publicación.",
    "deletePost": "Eliminar publicación",
    "deletePostFailed": "No se pudo eliminar la publicación. Intentar otra vez.",
    "organizerLibrary": "BIBLIOTECA ORGANIZADORA",
    "savedTemplates": "Plantillas guardadas",
    "loadingTemplates": "Cargando plantillas…",
    "eventTemplate": "PLANTILLA DE EVENTO",
    "useTemplate": "Usar plantilla",
    "deleteTemplate": "Eliminar plantilla",
    "deleteTemplateFailed": "No se pudo eliminar la plantilla. Intentar otra vez.",
    "deleteConfirm": "¿Eliminar \"{title}\"? Esto no se puede deshacer.",
    "noMatches": "No hay coincidencias",
    "noPosts": "Aún no hay publicaciones",
    "searchAgain": "Pruebe con un término de búsqueda diferente.",
    "noPostsSub": "Cree un evento o plan comunitario para comenzar.",
    "communityPlan": "PLAN COMUNITARIO",
    "officialEvent": "EVENTO OFICIAL",
    "noTemplates": "No hay plantillas guardadas",
    "noTemplatesSub": "Cree un evento y guárdelo como plantilla para reutilizarlo rápidamente.",
    "untitled": "Sin título",
    "noVenue": "Sin lugar"
  },
  "planRequests": {
    "empty": "No hay solicitudes pendientes",
    "emptySub": "Las solicitudes de unión de tus planes comunitarios aparecerán aquí.",
    "new": "NUEVO",
    "noMessage": "Sin mensaje",
    "decline": "Rechazar",
    "accept": "Aceptar",
    "acceptFailed": "No se pudo aceptar la solicitud. Por favor inténtalo de nuevo.",
    "declineFailed": "No se pudo rechazar la solicitud. Por favor inténtalo de nuevo.",
    "studiZoneAdmin": "ADMINISTRADOR STUDIZONE",
    "planAdmin": "ADMINISTRADOR DEL PLAN",
    "studiZoneRequests": "Solicitudes StudiZone",
    "joinRequests": "Solicitudes de unión",
    "traveler": "Viajero",
    "communityPlan": "Plan Comunitario",
    "viewProfile": "Ver perfil",
    "profileUnavailable": "Perfil no disponible",
    "profileUnavailableBody": "No se pudo encontrar el perfil de esta persona."
  },
  "publicProfile": {
    "reportFailed": "No se pudo enviar el informe",
    "blockTitle": "¿Bloquear usuario?",
    "blockFailed": "No se pudo bloquear al usuario",
    "profileUnavailableTitle": "Perfil no disponible",
    "profileUnavailableBody": "Este perfil ya no existe o no está disponible en este momento.",
    "vibeScore": "PUNTUACIÓN VIBE",
    "match": "% de coincidencia",
    "unvibe": "No vibra",
    "report": "Informe",
    "about": "Acerca de",
    "publicPlans": "Planes Públicos",
    "publicEvents": "Eventos públicos",
    "safetyHint": "Informar y bloquear acciones están disponibles desde tu menú de chat directo.",
    "safety": "SEGURIDAD",
    "optionalDetails": "Detalles opcionales...",
    "unvibeWith": "¿No vibras con {name}?",
    "unvibeBody": "Esto elimina tu conexión y chat directo.",
    "keepVibe": "Mantener Vibe",
    "community": "Comunidad Tonyte",
    "reportSubmitted": "Informe enviado",
    "blockMessage": "Ya no verás mensajes de {name}. El bloqueo es unidireccional y no les notificará.",
    "userBlocked": "Usuario bloqueado",
    "vibeSent": "Vibe enviado a {name}",
    "vibeSendFailed": "No se pudo enviar vibe",
    "noLongerVibing": "Tú y {name} ya no están vibrando",
    "unvibeFailed": "No pude dejar de vibrar en este momento",
    "message": "Mensaje",
    "vibeSentStatus": "Vibe Enviado",
    "sendVibe": "Enviar Vibe",
    "blocking": "Bloqueando...",
    "block": "Bloquear",
    "reportPerson": "Informe {name}",
    "sending": "Enviando...",
    "submitReport": "Enviar informe",
    "removing": "Eliminando...",
    "reasonSpam": "Spam",
    "reasonHarassment": "Acoso",
    "reasonFake": "Perfil falso",
    "reasonContent": "Contenido inapropiado",
    "reasonScam": "Estafa o comportamiento inseguro",
    "reasonOther": "Otro",
    "eventFallback": "Evento",
    "planFallback": "Plano"
  },
  "promotions": {
    "sectionTitle": "Colecciones",
    "explore": "Explorar eventos",
    "eventsCount": "{count} eventos",
    "collection": "Colección",
    "runs": "Del {range}",
    "dateRangeNote": "Eventos en estas fechas, no solo el día seleccionado en tu feed.",
    "unavailableTitle": "Esta colección no está disponible",
    "unavailableSub": "Puede que haya terminado o se haya eliminado. Mira el feed de eventos para ver qué hay ahora.",
    "backToEvents": "Volver a eventos"
  },
  "studiZone": {
    "locked": "StudiZone Bloqueado",
    "lockedSub": "Verifica tu condición de estudiante para desbloquear eventos estudiantiles, reuniones Erasmus, planes para el campus y vida nocturna universitaria.",
    "verifyStatus": "Verificar el estado del estudiante",
    "underConstruction": "en construcción",
    "constructionSub": "Estamos dando los últimos retoques a StudiZone. Su estado verificado se guarda; tendrá acceso completo cuando se inicie.",
    "verifiedLayer": "Capa de estudiantes verificada",
    "exit": "Salir",
    "loading": "Cargando StudiZone...",
    "createPlan": "Crear plan de estudiante",
    "planChat": "Plan de chat StudiZone · Miembros de {count}",
    "unlockedSub": "Los planes exclusivos para estudiantes, los chats y la vida nocturna del campus están desbloqueados para este perfil.",
    "planRequests": "Solicitudes de planes",
    "soon": "Pronto",
    "campusMap": "Mapa del campus",
    "studentPins": "Pines de estudiantes {count}",
    "openMap": "Abrir mapa completo",
    "emptyLane": "Nada en este carril todavía",
    "emptyLaneSub": "StudiZone está listo para lanzamientos exclusivos para estudiantes, sociedades, eventos en el campus y planes Erasmus.",
    "loadingMap": "Cargando mapa de estudiantes...",
    "mapTitle": "Mapa del campus",
    "pins": "Pines StudiZone",
    "tonyteStudent": "Tonyte Estudiante",
    "studentDiscounts": "Descuentos para estudiantes",
    "universityCommunities": "Comunidades universitarias",
    "societiesClubs": "Sociedades y clubes",
    "campusHeatmaps": "Mapas de calor del campus",
    "categoryAll": "Todos",
    "categoryCampus": "Campus",
    "categoryParties": "Fiestas",
    "categoryErasmus": "Erasmus",
    "categoryWorkshops": "Talleres",
    "categorySports": "Deportes",
    "categoryFree": "Gratis",
    "tabFeed": "Feed",
    "hey": "Hola {name}",
    "upcoming": "Próximamente",
    "eventsCount": "{count} eventos",
    "today": "Hoy",
    "tomorrow": "Mañana",
    "free": "Gratis",
    "verified": "Verificado",
    "timeTba": "Hora por confirmar",
    "campusMapSub": "Mira lo que pasa en el campus",
    "searchUniversities": "Buscar universidades",
    "dresden": "Dresde",
    "campusEventsCount": "{count} eventos en el campus",
    "noCampusEvents": "Aún no hay eventos en este campus",
    "noCampusEventsSub": "Los eventos con un edificio en este campus aparecen aquí.",
    "buildingFilter": "Edificio {code}",
    "noUniversityResults": "No se encontró ninguna universidad",
    "yourUniversity": "Tu uni",
    "campusesCount": "{count} campus",
    "allEvents": "Todos los eventos de StudiZone",
    "tabPlans": "Planes",
    "tabChats": "Charlas",
    "tabProfile": "Perfil"
  },
  "verification": {
    "signInSub": "Inicie sesión para iniciar la verificación.",
    "title": "Centro de verificación",
    "subtitle": "Administre insignias de confianza y acceso opcional a StudiZone desde un solo lugar.",
    "vibe": "Verificación Vibe",
    "retake": "Retomar",
    "student": "Verificación de Estudiante",
    "emailPlaceholder": "name@university.edu",
    "backToTonyte": "Volver a Tonyte",
    "validStudentEmail": "Ingrese una dirección de correo electrónico de estudiante válida.",
    "emailSent": "Correo electrónico de verificación enviado. Consulta la bandeja de entrada de tu universidad.",
    "emailSendFailed": "No se pudo enviar el correo electrónico de verificación.",
    "selfieTooSmall": "La selfie es demasiado pequeña o poco clara. Vuelve a tomarlo con buena luz y tu rostro visible.",
    "submitted": "Enviado para revisión.",
    "submitFailed": "No se pudo enviar la verificación.",
    "verified": "Verificado",
    "pending": "Pendiente",
    "failed": "Falló",
    "notVerified": "No verificado",
    "vibeDescription": "Una insignia de confianza y seguridad que muestra a otras personas que tu perfil pertenece a una persona real. Su selfie de verificación se revisa manualmente y se elimina una vez que se completa la decisión de verificación.",
    "studentDescription": "Verificación opcional para personas que quieran acceder a StudiZone. No cambia la experiencia principal de Tonyte.",
    "pendingReview": "Pendiente de revisión",
    "tryAgain": "Inténtalo de nuevo",
    "start": "Iniciar verificación",
    "submitting": "Enviando...",
    "submitReview": "Enviar para revisión",
    "poseGuideTitle": "Consigue tu Vibe Verificado",
    "poseGuideBody": "Verificación facial rápida\n\nTomaremos tres fotos automáticamente:\n• Mirando al frente\n• Mirando a tu izquierda\n• Mirando a tu derecha\n\nAsegúrate de que tu rostro sea claramente visible y de estar en un lugar bien iluminado.\n\nTus fotos se envían de forma segura para la verificación y pueden ser revisadas por el equipo de Tonyte.",
    "poseGuideOpenCamera": "Continuar",
    "camera": {
      "requestingPermission": "Solicitando acceso a la cámara…",
      "permissionDenied": "Se necesita acceso a la cámara para verificar tu Vibe. Actívalo en Ajustes e inténtalo de nuevo.",
      "openSettings": "Abrir Ajustes",
      "onePersonOnly": "Solo debe haber una persona en el encuadre",
      "of": "de",
      "moveIntoFrame": "Mueve tu rostro dentro del encuadre",
      "lookStraight": "Mira directamente a la cámara",
      "turnLeft": "Muestra tu perfil izquierdo",
      "turnRight": "Ahora muestra tu perfil derecho",
      "holdStill": "Mantente quieto…",
      "faceDetected": "Rostro detectado ✓",
      "frontCaptured": "✓ Frente capturado",
      "leftCaptured": "✓ Perfil izquierdo capturado",
      "rightCaptured": "✓ Perfil derecho capturado",
      "verificationComplete": "Ya tienes Vibe Verificado ✓",
      "uploading": "Subiendo tus fotos…",
      "fallbackMessage": "No se pudo verificar automáticamente. Puedes enviar tus fotos para revisión manual.",
      "fallbackSubmit": "Enviar para revisión manual",
      "tryAgain": "Inténtalo de nuevo",
      "errorGeneric": "No se pudo completar la verificación. Asegúrate de que tu rostro sea claramente visible e inténtalo de nuevo."
    }
  },
  "uploadPlan": {
    "signInBody": "Inicie sesión antes de crear un plan.",
    "missingDetails": "Detalles faltantes",
    "missingDetailsBody": "Agregue un título y una descripción del plan.",
    "missingLocation": "Ubicación faltante",
    "missingLocationBody": "Agregue el lugar y la ciudad de la reunión.",
    "missingDate": "Fecha faltante",
    "missingDateBody": "Seleccione la fecha y hora de inicio.",
    "participantLimit": "Límite de participantes",
    "participantLimitBody": "El límite de participantes del plan debe ser al menos 2.",
    "safetySetup": "Configuración de seguridad",
    "safetySetupBody": "Reconocer la responsabilidad de seguridad antes de publicar.",
    "invalidDate": "Fecha no válida",
    "futureDate": "Seleccione hoy o una fecha futura.",
    "invalidTime": "Hora no válida",
    "pastTime": "La hora de inicio no puede estar en el pasado.",
    "publishFailed": "No se pudo publicar el plan",
    "back": "← Atrás",
    "communityPlan": "Plan Comunitario",
    "createPlan": "Crear plan",
    "alwaysFree": "Los planes siempre son gratuitos",
    "alwaysFreeBody": "Los planes comunitarios no pueden habilitar pagos ni boletos.",
    "title": "Título del plan",
    "description": "Descripción del plan",
    "city": "Ciudad",
    "cityHelp": "Los planos solo se muestran dentro de la ciudad seleccionada.",
    "chooseCity": "Elige tu ciudad",
    "dateRange": "Rango de fechas",
    "dateRangeHelp": "Ayude a otros a saber cuándo y dónde reunirse.",
    "location": "Ubicación",
    "locationPlaceholder": "¿Dónde debería reunirse la gente?",
    "dateFrom": "Fecha de",
    "timeFrom": "Hora desde",
    "safety": "Configuración de seguridad",
    "safetyHelp": "Ayude a otros a comprender a qué tipo de plan se están uniendo.",
    "hostedAt": "Alojado en",
    "hostedHelp": "Elija si este plan está alojado en un lugar público, privado o tipo de ubicación desconocida.",
    "visibility": "Visibilidad del plan",
    "visibilityHelp": "Elige quién puede discover este plan.",
    "maxParticipants": "Máximo de participantes (opcional)",
    "unlimited": "Dejar vacío para ilimitado",
    "responsibility": "Entiendo que soy responsable de crear un plan seguro y respetuoso.",
    "publish": "Publicar plan",
    "publicPlace": "Lugar público",
    "privatePlace": "Lugar privado",
    "unknown": "Desconocido",
    "public": "Público",
    "friends": "Amigos",
    "inviteOnly": "Sólo por invitación",
    "startedFromTemplate": "Basado en una plantilla de Tonyte",
    "endsAt": "El plan termina",
    "endsAtHelp": "El plan desaparece de Tonyte después de esta hora y luego se elimina automáticamente.",
    "endDate": "Fecha de fin",
    "endTime": "Hora de fin",
    "missingEnd": "Falta la hora de fin",
    "missingEndBody": "Elige cuándo termina el plan.",
    "endBeforeStart": "El plan debe terminar después de empezar.",
    "endTooLate": "Un plan puede durar como máximo 14 días."
  },
  "uploadEvent": {
    "signInBody": "Inicia sesión antes de publicar un evento.",
    "missingDetails": "Detalles faltantes",
    "missingDetailsBody": "Agrega un título y una descripción del evento.",
    "missingDate": "Fecha faltante",
    "missingDateBody": "Seleccione la fecha y hora de inicio.",
    "participantLimit": "Límite de participantes",
    "participantLimitBody": "Ingrese 0 para ilimitado o un límite de participantes mayor que 0.",
    "invalidDate": "Fecha no válida",
    "futureDate": "Seleccione hoy o una fecha futura.",
    "invalidTime": "Hora no válida",
    "startPast": "La hora de inicio no puede estar en el pasado.",
    "endBeforeStart": "La fecha de finalización no puede ser anterior a la fecha de inicio.",
    "endTimeBeforeStart": "La hora de finalización debe ser posterior a la hora de inicio.",
    "untilBeforeStart": "La fecha hasta no puede ser anterior a la fecha de inicio del evento.",
    "tagRequired": "Se requiere etiqueta de evento",
    "tagRequiredBody": "Seleccione al menos una etiqueta de evento para que las personas puedan discover su evento.",
    "permissionRequired": "Se requiere permiso",
    "editPermission": "Solo los administradores, coadministradores y el organizador del evento pueden editar este evento.",
    "addressWarning": "No pudimos verificar esta dirección exacta, pero la guardaremos tal como se escribió.",
    "publishFailed": "No se pudo publicar el evento",
    "back": "← Atrás",
    "officialEvent": "Evento oficial",
    "editEvent": "Editar evento",
    "repostEvent": "Volver a publicar evento",
    "fromTemplate": "Nuevo desde plantilla",
    "createEvent": "Crear evento",
    "addCover": "Agregar foto de portada",
    "invalidImage": "Imagen del evento no válida",
    "imageTooLarge": "Elige una imagen de menos de 15 MB.",
    "unsupportedImage": "Elige una imagen JPEG, PNG, WebP, HEIC o HEIF.",
    "title": "Título del evento",
    "description": "Descripción del evento",
    "venueOrganizer": "Lugar / organizador",
    "lineup": "Alineación/hosts (separados por comas)",
    "websiteUrl": "URL del sitio web",
    "instagramUrl": "URL de Instagram",
    "sourceUrl": "URL de la página de origen/evento",
    "location": "Ubicación",
    "locationHelp": "Busca un lugar o dirección. Seleccione entre las sugerencias para fijar su evento en el mapa.",
    "city": "Ciudad",
    "cityHelp": "Los eventos solo se muestran dentro de la ciudad seleccionada.",
    "dateRange": "Rango de fechas",
    "dateRangeHelp": "Establece la ventana de fecha y hora del evento público.",
    "dateFrom": "Fecha de",
    "dateTo": "Fecha hasta",
    "timeFrom": "Hora desde",
    "timeTo": "Hora de",
    "lastEntry": "Última hora de entrada",
    "lastEntryHelp": "Ocultar este evento de En curso después de este tiempo, incluso si finaliza más tarde.",
    "eventTags": "ETIQUETAS DE EVENTO",
    "tagsHelp": "Seleccione todo lo que corresponda · al menos uno requerido",
    "maxParticipants": "Máximo de participantes",
    "maxParticipantsHelp": "Ingrese 0 para participantes ilimitados.",
    "maxParticipantsPlaceholder": "Máximo de participantes",
    "freeEvent": "Evento gratuito",
    "freeEventHelp": "Todos los eventos son gratuitos en la versión actual Tonyte.",
    "saveTemplate": "Guardar como plantilla",
    "saveTemplateHelp": "Guarda esta publicación completa del evento para subirla en el futuro.",
    "saveCurrentTemplate": "Guardar los campos actuales como plantilla",
    "recurring": "Evento recurrente",
    "recurringHelp": "Utilice los campos de plantilla y cree múltiples instancias de eventos.",
    "oneTime": "Evento único",
    "weekly": "Semanal",
    "custom": "Personalizado",
    "repeatEvery": "Repetir cada",
    "until": "Hasta",
    "occurrences": "Ocurrencias",
    "customDates": "Fechas de eventos personalizados",
    "customDatesHelp": "Fechas separadas por comas, p. 2026-06-15, 2026-06-22",
    "skipDates": "Saltar fechas",
    "skipDatesHelp": "Fechas separadas por comas para omitir.",
    "saveEvent": "Guardar evento",
    "publishRepost": "Publicar Volver a publicar",
    "publishEvent": "Publicar evento",
    "selectCity": "Selecciona ciudad",
    "locationRequired": "Ubicación requerida",
    "locationRequiredBody": "Busque y seleccione una ubicación entre las sugerencias para que su evento pueda aparecer en el mapa.",
    "ok": "Aceptar",
    "hashtags": "Hashtags",
    "selected": "seleccionado",
    "addHashtags": "Agregar hashtags",
    "collapseHashtags": "Contraer hashtags",
    "hashtagsHelp": "Busca o agrega hashtags de eventos. Separe varios hashtags con comas."
  },
  "venueProfiles": {
    "open": "Abrir",
    "mapUnavailable": "Mapa no disponible",
    "noAddress": "Este lugar aún no incluye una dirección.",
    "mapOpenFailed": "No se pudo abrir el mapa",
    "followers": "Seguidores",
    "posts": "Publicaciones",
    "events": "Eventos",
    "upcoming": "Próximo",
    "past": "Pasado",
    "about": "Acerca de",
    "calendar": "Calendario",
    "noEventsOnDay": "No hay eventos este día.",
    "yourVenue": "Tu perfil",
    "editProfile": "Editar perfil",
    "editLoadFailed": "No se pudo cargar tu perfil",
    "editSaveFailed": "No se pudieron guardar los cambios",
    "editNotAllowed": "Solo el propietario puede editar este perfil.",
    "coverPhoto": "Foto de portada",
    "profilePhoto": "Foto de perfil",
    "changePhoto": "Cambiar",
    "coverHint": "Arrastra para mover, pellizca o usa el control para hacer zoom. Se verá exactamente así en tu perfil y en Vibe at Venues.",
    "adjustPhoto": "Ajustar",
    "bioLabel": "Bio",
    "bioPlaceholder": "Cuenta de qué trata tu lugar",
    "categoryLabel": "Categoría",
    "dashboard": "Panel de analíticas",
    "analytics": "Analíticas",
    "calendarImports": "Importaciones de calendario",
    "unavailable": "Este perfil no está disponible.",
    "calendarImportsSub": "Revisa y publica tus eventos importados",
    "dashboardSub": "Toques, interés, compartidos y rendimiento de eventos",
    "follow": "Seguir",
    "following": "Siguiendo",
    "organizerNotFound": "Organizador no encontrado",
    "organizerUnavailable": "Este perfil de organizador aún no está disponible.",
    "vibesTitle": "Vibe en Lugares",
    "vibesSubtitle": "Encuentra los lugares donde se reúne tu gente.",
    "search": "Busca locales, discotecas, cafeterías, bares...",
    "refreshFailed": "No se pudieron actualizar las publicaciones del lugar. Mostrando lo que está disponible.",
    "noVenues": "No se encontraron lugares",
    "noVenuesSub": "Prueba con otra búsqueda o categoría.",
    "signInFollowVenue": "Inicia sesión antes de los siguientes lugares.",
    "signInFollowOrganizer": "Inicia sesión antes de seguir a los organizadores.",
    "signInLike": "Inicia sesión antes de que te gusten las publicaciones del lugar.",
    "signInComment": "Inicie sesión antes de comentar las publicaciones del lugar.",
    "signInDeleteComment": "Inicie sesión antes de eliminar comentarios.",
    "notAllowed": "No permitido",
    "ownCommentsOnly": "Solo puedes eliminar tus propios comentarios."
  },
  "verificationComplete": {
    "noToken": "No se encontró ningún token de verificación. Utilice el enlace de su correo electrónico.",
    "couldNotComplete": "No se pudo completar la verificación.",
    "expiredBody": "Este enlace ha caducado. Solicite un nuevo correo electrónico de verificación en la aplicación.",
    "invalidBody": "Este enlace de verificación no es válido o ya ha sido utilizado.",
    "verifying": "Verificando…",
    "verified": "Correo electrónico del estudiante verificado",
    "underReview": "En revisión",
    "expired": "Enlace caducado",
    "invalid": "Enlace no válido",
    "failed": "Verificación fallida",
    "checking": "Comprobando la verificación de tu correo electrónico de estudiante…",
    "verifiedUniversity": "Correo electrónico del estudiante verificado. Bienvenido a StudiZone. Tu condición de estudiante {university} ha sido confirmada.",
    "verifiedWelcome": "Correo electrónico del estudiante verificado. Bienvenido a StudiZone.",
    "pendingBody": "Se confirmó la propiedad del correo electrónico. Su verificación de estudiante está pendiente de revisión.",
    "back": "Volver a Tonyte"
  },
  "permissions": {
    "locationTitle": "¿Usar tu ubicación?",
    "locationMessage": "Tonyte usa tu ubicación para mostrar eventos y planes cercanos.",
    "notificationsTitle": "¿Activar notificaciones?",
    "notificationsMessage": "Tonyte utiliza notificaciones para mensajes nuevos, actualizaciones de planes y recordatorios de eventos.",
    "cameraTitle": "¿Usas tu cámara?",
    "cameraMessage": "Tonyte usa tu cámara cuando eliges tomar fotos para tu perfil, eventos, planes o verificación facial.",
    "microphoneTitle": "¿Usas tu micrófono?",
    "microphoneMessage": "Tonyte necesita acceso al micrófono para enviar notas de voz.",
    "locationLabel": "ubicación",
    "notificationsLabel": "notificaciones",
    "cameraLabel": "cámara",
    "microphoneLabel": "micrófono",
    "disabled": "Permiso deshabilitado",
    "notGranted": "Permiso no concedido",
    "blockedBody": "Tonyte no tiene acceso a tu {permission}. Puedes habilitarlo en Configuración.",
    "deniedBody": "Puedes continuar sin acceso a {permission}. Algunas funciones pueden ser limitadas."
  },
  "notifications": {
    "newJoinRequest": "Nueva solicitud de unión",
    "newJoinRequestBody": "Tienes una nueva solicitud para unirte.",
    "planAccepted": "Ya estás dentro 🎉",
    "planAcceptedBody": "Has sido aceptado en un plan.",
    "newVibeRequest": "Nueva solicitud de Vibe ✨",
    "newVibeRequestBody": "Alguien quiere vibrar contigo.",
    "vibeAccepted": "¡Es un Vibe! ✨",
    "vibeAcceptedBody": "Tu solicitud de Vibe fue aceptada.",
    "eventsTitle": "Qué pasa en Dresde",
    "eventsBody": "Hay nuevos eventos esperándote.",
    "vibePlanTitle": "Uno de tus vibes creó un plan",
    "vibePlanBody": "Toca para ver el plan y unirte.",
    "partnerUpdateTitle": "Novedades de un partner que sigues",
    "partnerUpdateBody": "Mira lo nuevo.",
    "newFollowerTitle": "Tienes un nuevo seguidor 🧡",
    "newFollowerBody": "Alguien acaba de seguirte en Tonyte.",
    "profilePhotoReminderTitle": "Completa tu perfil de Tonyte 👋",
    "profilePhotoReminderBody": "Añade una foto de perfil para desbloquear Planes y Vibes.",
    "appUpdateReminderTitle": "Te espera un Tonyte mejor 🧡",
    "appUpdateReminderBody": "Actualiza Tonyte para obtener las últimas funciones, correcciones y mejoras."
  },
  "vibeClaim": {
    "playedOnWeb": "¿Jugaste al juego Vibe en la web?",
    "enterCodeTitle": "Añade tus respuestas de la web",
    "enterCodeBody": "Introduce el código del final del juego Vibe en tonyte.app.",
    "continue": "Continuar",
    "ok": "OK",
    "invalidFormat": "Los códigos tienen este formato: ABCD-EFGH.",
    "invalidCode": "Ese código no existe o ha caducado.",
    "oldRoundCode": "Ese código era de una ronda anterior que ya ha terminado.",
    "alreadyClaimedCode": "Esas respuestas ya se añadieron a una cuenta de Tonyte.",
    "savedSignIn": "¡Listo! Inicia sesión o crea una cuenta y añadiremos tus respuestas.",
    "networkError": "No se pudo comprobar el código. Revisa tu conexión e inténtalo de nuevo.",
    "rateLimited": "Demasiados intentos. Espera unos minutos.",
    "waitingBanner": "Tus respuestas Vibe de la web te esperan. Inicia sesión o regístrate para ver tus vibes.",
    "discard": "Descartar respuestas de la web",
    "addedToast": "Tus respuestas de la web ya están ✨",
    "unlocksAt13": "Tus primeras vibes se desbloquean a las 13:00.",
    "alreadyPlayedTodayTitle": "Ya jugaste al juego Vibe de hoy",
    "alreadyPlayedTodayBody": "Tus respuestas de hoy ya están. Cada cuenta juega una vez al día, así que no se puede añadir un código de la web encima. Mañana a las 6:00 empieza una nueva ronda.",
    "addingTitle": "Añadiendo tus respuestas de la web…",
    "addingBody": "Estamos añadiendo las respuestas del código que introdujiste. Solo tarda un momento.",
    "notOpenTitle": "El juego de hoy aún no está abierto",
    "notOpenBody": "El juego Vibe abre a las 6:00. Los códigos solo sirven el día en que jugaste.",
    "seeMyVibes": "Ver mis vibes",
    "alreadyPlayedTitle": "Ya jugaste hoy",
    "alreadyPlayedBody": "Ya habías respondido las preguntas Vibe de hoy en la app, así que mantuvimos esas. Las respuestas quedan fijadas, por eso no se usaron las de la web.",
    "roundClosedTitle": "Esas respuestas eran del {date}",
    "roundClosedBody": "Las respuestas de la web solo cuentan en la ronda en que se jugaron, y esa ronda ya terminó. Las preguntas de hoy te esperan en Day Vibes.",
    "playToday": "Jugar hoy",
    "claimedElsewhereTitle": "Ya están en otra cuenta",
    "claimedElsewhereBody": "Estas respuestas se añadieron a otra cuenta de Tonyte. Cada conjunto de respuestas solo puede pertenecer a una cuenta.",
    "notFoundTitle": "No se pudieron añadir esas respuestas",
    "notFoundBody": "El enlace o el código ha caducado o no es válido. Las respuestas de la web se pueden añadir hasta la medianoche (hora de Berlín) del día en que jugaste.",
    "notEligibleBody": "Day Vibes no está disponible para este tipo de cuenta.",
    "emailFoundTitle": "¿Añadir tus respuestas de la web?",
    "emailFoundBody": "Guardaste las respuestas Vibe de hoy en tonyte.app con {email}. ¿Añadirlas a esta cuenta?",
    "addAnswers": "Añadir",
    "notNow": "Ahora no"
  },
  partnerCommunity: {
    button: 'Community chat',
    followToJoinTitle: 'Follow to join?',
    followToJoinBody: 'Follow {name} to join their community chat.',
    followAndJoin: 'Follow & join',
    signIn: 'Sign in to join this partner’s community. You’ll return here afterward.',
    signInAction: 'Sign in',
    joinFailed: 'Couldn’t join the community. Please try again.',
    unfollowTitle: 'Unfollow and leave community?',
    unfollowBody: 'Unfollowing {name} also removes you from their community chat.',
    unfollowAndLeave: 'Unfollow & leave',
    messagesTab: 'Messages',
    notificationsTab: 'Notifications',
    communitiesTab: 'Community Chats',
    incoming: 'Incoming requests',
    outgoing: 'Outgoing requests',
    emptyTitle: 'Find your communities',
    emptyBody: 'Follow a partner and join their community to chat with people around it.',
    discover: 'Discover partners',
    about: 'The official member chat for this partner.',
    memberOnly: 'Followers’ community',
    leaveConfirm: 'Leave this community chat? You will keep following the partner.',
    ownerCannotLeave: 'You administer this community as the partner owner.',
    accessRemoved: 'You no longer have access to this community.',
    allowBack: 'Allow back',
    allowedBack: 'This person can rejoin after following the partner.',
    rejoined: 'Member reinstated.',
    descriptionPlaceholder: 'Añade una descripción de la comunidad…',
    descriptionSaved: 'Descripción de la comunidad actualizada.',
    descriptionSaveFailed: 'No se pudo actualizar la descripción.',
    admin: 'Admin',
    coAdmin: 'Co-admin',
    makeCoAdmin: 'Hacer co-admin',
    removeCoAdmin: 'Quitar rol de co-admin',
    coAdminAdded: '{name} ahora es co-admin.',
    coAdminRemoved: '{name} ya no es co-admin.',
  },
  "partnerReviews": {
    "tab": "Reseñas",
    "reviewCount_one": "{count} reseña",
    "reviewCount_other": "{count} reseñas",
    "ratingCount_one": "{count} valoración",
    "ratingCount_other": "{count} valoraciones",
    "starCount_one": "{count} estrella",
    "starCount_other": "{count} estrellas",
    "noReviewsYet": "Aún no hay reseñas",
    "beFirst": "Escribe la primera",
    "summaryA11y": "Valorado con {avg} de 5 en {count} reseñas. Ver reseñas",
    "write": "Escribir una reseña",
    "edit": "Editar tu reseña",
    "ownProfile": "Las reseñas vienen de visitantes: no puedes valorar tu propio perfil.",
    "signInToReview": "Inicia sesión o crea una cuenta para escribir una reseña.",
    "filterAll": "Todas",
    "empty": "Aún no hay reseñas",
    "emptySub": "¿Has estado aquí? Cuenta qué tal fue y ayuda a otras personas a decidir.",
    "emptyFiltered": "Aún no hay reseñas de {count} estrellas.",
    "loadFailed": "No se pudieron cargar las reseñas.",
    "retry": "Reintentar",
    "showMore": "Ver más reseñas",
    "edited": "Editada",
    "readMore": "Leer más",
    "showLess": "Ver menos",
    "yourReview": "Tu reseña",
    "hiddenNotice": "Solo tú ves esta reseña mientras nuestro equipo la revisa.",
    "removedNotice": "Nuestro equipo de moderación eliminó esta reseña. Puedes borrarla y escribir una nueva.",
    "menu": "Opciones de la reseña",
    "titleNew": "Valorar {name}",
    "titleEdit": "Editar tu reseña",
    "aboutPartner": "Valoras {name} en general, no un evento concreto.",
    "draftRestored": "Hemos guardado tu reseña sin terminar.",
    "ratingLabel": "Tu valoración",
    "tapToRate": "Toca una estrella para valorar",
    "ratingRequired": "Elige una valoración con estrellas para continuar.",
    "textLabel": "Tu reseña (opcional)",
    "placeholder": "¿Qué tal fue? Ambiente, gente, eventos…",
    "submit": "Publicar reseña",
    "update": "Guardar cambios",
    "posted": "¡Gracias por tu reseña!",
    "updated": "Reseña actualizada",
    "deleted": "Reseña eliminada",
    "deleteTitle": "¿Eliminar tu reseña?",
    "deleteBody": "Tu valoración y tu texto se eliminarán de {name}.",
    "ratingWords": {
      "1": "No es para mí",
      "2": "Podría mejorar",
      "3": "Bien",
      "4": "Muy bien",
      "5": "Me encantó"
    },
    "actions": {
      "edit": "Editar reseña",
      "delete": "Eliminar reseña",
      "report": "Denunciar reseña",
      "hide": "Ocultar reseña (admin)",
      "restore": "Restaurar reseña (admin)",
      "remove": "Retirar reseña (admin)",
      "dismiss": "Descartar denuncias"
    },
    "confirm": {
      "hideTitle": "¿Ocultar esta reseña?",
      "hideBody": "Desaparece del perfil y deja de contar en la valoración hasta que se restaure.",
      "removeTitle": "¿Retirar esta reseña?",
      "removeBody": "El texto se borra y deja de contar en la valoración. No se puede deshacer.",
      "dismissTitle": "¿Descartar estas denuncias?",
      "dismissBody": "La reseña sigue visible y las denuncias se cierran."
    },
    "moderated": {
      "hide": "Reseña ocultada",
      "restore": "Reseña restaurada",
      "remove": "Reseña retirada",
      "dismiss": "Denuncias descartadas"
    },
    "reportTitle": "Denunciar esta reseña",
    "reportReason": "¿Por qué la denuncias?",
    "reasons": {
      "spam": "Spam o publicidad",
      "harassment": "Acoso u odio",
      "inappropriate": "Contenido inapropiado",
      "fake": "Falsa o engañosa",
      "other": "Otra cosa"
    },
    "reportDetails": "¿Algo más que debamos saber? (opcional)",
    "reportSubmit": "Enviar denuncia",
    "reported": "Gracias, nuestro equipo lo revisará.",
    "errors": {
      "signIn": "Vuelve a iniciar sesión para publicar tu reseña. Tu borrador está guardado.",
      "verifyEmail": "Verifica tu correo para publicar reseñas. Tu borrador está guardado.",
      "ownProfile": "No puedes valorar tu propio perfil.",
      "removed": "El equipo de moderación retiró esta reseña y no se puede editar.",
      "rating": "Elige una valoración de 1 a 5 estrellas.",
      "tooLong": "Las reseñas pueden tener como máximo 1000 caracteres.",
      "unavailable": "Este perfil no está disponible.",
      "reviewGone": "Esta reseña ya no está disponible.",
      "ownReview": "No puedes denunciar tu propia reseña.",
      "access": "Tu cuenta no puede publicar reseñas ahora mismo.",
      "network": "Problema de conexión: inténtalo de nuevo. Tu borrador está guardado.",
      "generic": "Algo salió mal. Inténtalo de nuevo."
    },
    "admin": {
      "title": "Reseñas denunciadas",
      "profileSub": "Ocultar o retirar reseñas de partners denunciadas",
      "open": "Abiertas",
      "resolved": "Resueltas",
      "empty": "No hay reseñas denunciadas.",
      "reason": "Motivo",
      "details": "Detalles",
      "reportedAt": "Denunciada el {date}",
      "currentStatus": "Ahora",
      "status": {
        "published": "Visible",
        "hidden": "Oculta",
        "removed": "Retirada",
        "missing": "Eliminada"
      },
      "resolution": {
        "hidden": "Ocultada",
        "removed": "Retirada",
        "dismissed": "Descartada",
        "review_deleted": "Eliminada por su autor/a",
        "restored": "Restaurada"
      },
      "openProfile": "Abrir perfil",
      "loadFailed": "No se pudieron cargar las denuncias."
    }
  }
};
